// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  min-width: 0;
  overflow: hidden;
}

mat-form-field {
  width: 100%;
}

.chat-container {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  container-type: inline-size;
  container-name: chat;
}
.chat-container .main-chat-container {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

:host([isfullscreen=true]) .chat-container {
  height: 100%;
}

.content {
  flex: 1 1 0%;
  overflow: hidden;
}

.header-bar {
  padding: 0.25rem;
  display: flex;
  z-index: 100;
  position: relative;
}
.header-bar .section {
  display: flex;
  align-items: center;
  gap: 4px;
}
.header-bar .section.left {
  flex: 1;
  overflow: hidden;
}
.header-bar .section.right {
  margin-left: auto;
  flex-shrink: 0;
}
.header-bar .chat-title {
  margin: 0 0.75rem;
  font-size: 1.125rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.header-bar .model-selector {
  box-sizing: border-box;
  font-weight: 600;
  font-size: 1.125rem;
  width: 320px;
  height: 2.5rem;
  line-height: 1.75rem;
  padding: 0.375rem 0.75rem;
  border-radius: 0.5rem;
  overflow: hidden;
  align-items: center;
  display: flex;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}

.model-listing {
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-template-rows: 1fr 1rem;
  gap: 0px 12px;
  grid-template-areas: "icon name" "icon desc";
}
.model-listing .model-icon {
  margin: 0;
  grid-area: icon;
  width: 32px;
  height: 32px;
  align-self: center;
}
.model-listing .model-name {
  grid-area: name;
}
.model-listing .model-description {
  grid-area: desc;
  font-size: 0.75rem;
  line-height: 1rem;
}

/* pulling-models-info removed - replaced by agent selector */
.square-button {
  --square-button-size: 40px;
  width: var(--square-button-size, 48px);
  height: var(--square-button-size, 48px);
  padding: calc((var(--square-button-size, 48px) - var(--square-icon-size, 24px)) / 2);
  border-radius: 0.5rem;
}
.square-button mat-icon {
  width: var(--square-icon-size, 24px);
  height: var(--square-icon-size, 24px);
  line-height: var(--square-icon-size, 24px);
  font-size: var(--square-icon-size, 24px);
}
.square-button ::ng-deep .mat-mdc-button-persistent-ripple {
  border-radius: 0.5rem;
}
.square-button ::ng-deep .mat-mdc-button-touch-target {
  width: var(--square-button-size, 48px);
  height: var(--square-button-size, 48px);
}

.new-convo {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.new-convo .brand {
  height: 48px;
  width: 48px;
  font-size: 48px;
}
.new-convo .samples {
  margin: 3rem 0.75rem 0;
  max-width: 48rem;
  gap: 1rem;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  max-width: 48rem;
  display: flex;
}
.new-convo .samples .sample {
  border: 1px solid;
  border-radius: 1rem;
  cursor: pointer;
  color: inherit;
  padding: 0.75rem 0.75rem 1rem;
  font-size: 15px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: left;
  align-items: flex-start;
}
.new-convo .samples .sample > mat-icon {
  font-family: "Material Icons Outlined";
}

.user-input {
  padding-bottom: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 25px;
  z-index: 10;
  background: var(--chat-area-bg, var(--surface-color, white));
}
.user-input .prompt-box {
  margin: 0 auto;
  display: flex;
  flex-grow: 1;
  padding: 10px 0.75rem 0;
}
@media (min-width: 1200px) {
  .user-input .prompt-box {
    max-width: 48rem;
    padding: 0 1.25rem;
  }
}
@media (min-width: 992px) {
  .user-input .prompt-box {
    max-width: 40rem;
    padding: 0 0.25rem;
  }
}
@media (min-width: 768px) {
  .user-input .prompt-box {
    max-width: 48rem;
    padding: 0 1rem;
  }
}
.user-input .input-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  margin-right: 8px;
}
.user-input .input-actions .upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}
.user-input .input-actions .upload-btn:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.08);
}
.user-input .input-actions .upload-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.user-input .input-actions .voice-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}
.user-input .input-actions .voice-btn:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.08);
}
.user-input .input-actions .voice-btn.recording {
  opacity: 1;
  background-color: #f44336;
  color: white;
  animation: pulse-recording 1.5s ease-in-out infinite;
}
.user-input .input-actions .voice-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
@keyframes pulse-recording {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(244, 67, 54, 0);
  }
}
.user-input .pending-image-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  position: relative;
  max-width: 100%;
}
.user-input .pending-image-preview img {
  max-height: 120px;
  max-width: 200px;
  border-radius: 8px;
  object-fit: contain;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.user-input .pending-image-preview .remove-image-btn {
  position: absolute;
  top: 0;
  right: calc(50% - 108px);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease;
}
.user-input .pending-image-preview .remove-image-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}
.user-input .pending-image-preview .remove-image-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.user-input .mistake-warning {
  font-size: 0.75rem;
  line-height: 1rem;
  text-align: center;
  padding: 0.5rem 0;
}

/* Agent selector - matches model-selector styling in header-bar */
.agent-selector {
  box-sizing: border-box;
  font-weight: 600;
  font-size: 1rem;
  width: 280px;
  height: 2.5rem;
  line-height: 1.75rem;
  padding: 0.375rem 0.75rem;
  border-radius: 0.5rem;
  overflow: hidden;
  align-items: center;
  display: flex;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}
.agent-selector ::ng-deep .mat-mdc-select-trigger {
  height: 100%;
}
.agent-selector ::ng-deep .mat-mdc-select-value {
  max-width: 100%;
}
.agent-selector ::ng-deep .mat-mdc-select-arrow-wrapper {
  padding-left: 8px;
}

.agent-listing {
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 0 10px;
  align-items: center;
}
.agent-listing .agent-icon {
  width: 24px;
  height: 24px;
  font-size: 24px;
  color: var(--primary-color, #1976d2);
}
.agent-listing .agent-name {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-history-container {
  display: flex;
  height: 100%;
  min-width: 200px;
  max-width: 500px;
  padding: 0.75rem;
  padding-top: 0;
  flex-direction: column;
  flex-shrink: 0;
  container-type: inline-size;
  container-name: sidebar;
}
.chat-history-container.selection-mode {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.chat-history-container .nav-action-bar {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
}
.chat-history-container .nav-action-bar .nav-logo {
  height: 30px;
  width: auto;
  object-fit: contain;
  object-position: left center;
}
.chat-history-container .search-action-row {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  gap: 0.25rem;
}
.chat-history-container .search-action-row .search-field {
  flex: 1;
  min-width: 0;
}
.chat-history-container .search-action-row .search-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.chat-history-container .search-action-row .search-field ::ng-deep .mat-mdc-text-field-wrapper {
  padding: 0 0.5rem;
}
.chat-history-container .search-action-row .search-field ::ng-deep .mat-mdc-form-field-infix {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  min-height: unset;
}
.chat-history-container .search-action-row .search-field ::ng-deep input {
  font-size: 0.8125rem;
}
.chat-history-container .search-action-row .search-field mat-icon[matPrefix] {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 0.25rem;
  opacity: 0.6;
}
.chat-history-container .search-action-row .search-field ::ng-deep .mat-mdc-form-field-icon-suffix {
  display: flex;
  align-items: center;
  padding-right: 0.25rem;
}
.chat-history-container .search-action-row .search-field mat-spinner {
  margin-left: 0.25rem;
  flex-shrink: 0;
}
.chat-history-container .search-action-row > .action-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  flex-shrink: 0;
}
.chat-history-container .search-action-row > .action-btn mat-icon {
  font-size: 20px;
  line-height: 32px;
  width: 24px;
  height: 24px;
}
.chat-history-container .search-action-row > .action-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 32px;
  height: 32px;
}
.chat-history-container .search-action-row > .action-btn.new-chat-btn mat-icon {
  color: var(--preset-primary, var(--mat-theme-primary, #1976d2)) !important;
}
.chat-history-container .search-action-row.selection-bar .selection-count {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--preset-primary, var(--mat-theme-primary, #1976d2));
  white-space: nowrap;
}
.chat-history-container .search-action-row.selection-bar .flex-spacer {
  flex: 1;
}
.chat-history-container .chat-history {
  display: flex;
  flex-direction: column;
  gap: var(--density-spacing, 1rem);
  margin: 0.5rem 0;
  font-size: 0.875rem;
  line-height: 1.25rem;
  overflow: hidden auto;
  flex: 1;
}
.chat-history-container .chat-history-block {
  position: relative;
}
.chat-history-container .chat-history-block .block-header {
  position: sticky;
  top: 0;
}
.chat-history-container .chat-history-block .block-header span {
  padding: 0.75rem 0.5rem 0.5rem;
  font-weight: 600;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  pointer-events: none;
  cursor: default;
}

.chat-history-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.chat-history-list li {
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--density-padding, 0.5rem);
  cursor: pointer;
}

.sidebar-resize-divider {
  width: 4px;
  cursor: ew-resize;
  background-color: var(--resize-divider-color, transparent);
  transition: background-color 0.15s ease, width 0.15s ease;
  flex-shrink: 0;
}
.sidebar-resize-divider:hover {
  background-color: var(--primary-color, #1976d2);
  opacity: 0.5;
}
.sidebar-resize-divider.collapsed {
  width: 6px;
  cursor: e-resize;
  opacity: 0.7;
}
.sidebar-resize-divider.collapsed:hover {
  width: 8px;
  opacity: 1;
}

.open-apps-section {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--border-color, rgba(128, 128, 128, 0.2));
}
.open-apps-section .open-apps-header {
  padding: 0 0.5rem 0.5rem;
}
.open-apps-section .open-apps-header span {
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--text-secondary, rgba(128, 128, 128, 0.8));
}
.open-apps-section .open-apps-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.open-apps-section .open-apps-list li {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.open-apps-section .open-apps-list li:hover {
  background-color: var(--hover-color, rgba(0, 0, 0, 0.04));
}
.open-apps-section .open-apps-list li.active {
  background-color: var(--active-color, rgba(var(--primary-color-rgb, 25, 118, 210), 0.12));
}
.open-apps-section .open-apps-list li .app-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin-right: 0.5rem;
  color: var(--primary-color, #1976d2);
}
.open-apps-section .open-apps-list li .app-name {
  flex: 1;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.open-apps-section .open-apps-list li .close-app-btn {
  width: 20px;
  height: 20px;
  padding: 0;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.open-apps-section .open-apps-list li .close-app-btn mat-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
}
.open-apps-section .open-apps-list li:hover .close-app-btn {
  opacity: 0.6;
}
.open-apps-section .open-apps-list li:hover .close-app-btn:hover {
  opacity: 1;
}

.split-content-area {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  min-height: 0;
  position: relative;
  z-index: 1;
}

.app-pane {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 100px;
  flex-shrink: 0;
}
.app-pane.hidden {
  height: 0 !important;
  min-height: 0 !important;
  overflow: hidden;
}
.app-pane .app-tabs-bar {
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  min-height: 36px;
  background-color: var(--surface-color, rgba(128, 128, 128, 0.05));
  border-bottom: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));
}
.app-pane .app-tabs-bar > .pane-toggle-btn {
  margin-right: 0.25rem;
}
.app-pane .app-tabs-bar .app-tabs {
  display: flex;
  flex: 1;
  overflow-x: auto;
  gap: 2px;
}
.app-pane .app-tabs-bar .app-tabs::-webkit-scrollbar {
  height: 4px;
}
.app-pane .app-tabs-bar .app-tabs .app-tab {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.5rem;
  border-radius: 0.375rem 0.375rem 0 0;
  cursor: pointer;
  font-size: 0.8125rem;
  white-space: nowrap;
  transition: background-color 0.15s ease, color 0.15s ease;
  border: 1px solid transparent;
  border-bottom: none;
  height: 28px;
  box-sizing: border-box;
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
}
.app-pane .app-tabs-bar .app-tabs .app-tab:hover {
  background-color: var(--hover-color, rgba(0, 0, 0, 0.04));
  color: var(--text-primary, rgba(0, 0, 0, 0.87));
}
.app-pane .app-tabs-bar .app-tabs .app-tab.active {
  background-color: var(--surface-color, rgba(128, 128, 128, 0.1));
  border-color: var(--border-color, rgba(128, 128, 128, 0.2));
  color: inherit;
}
.app-pane .app-tabs-bar .app-tabs .app-tab .tab-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  margin-right: 0.375rem;
  flex-shrink: 0;
}
.app-pane .app-tabs-bar .app-tabs .app-tab .tab-name {
  margin-right: 0.375rem;
  line-height: 1;
}
.app-pane .app-tabs-bar .app-tabs .app-tab .tab-close {
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  padding: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;
}
.app-pane .app-tabs-bar .app-tabs .app-tab .tab-close ::ng-deep .mat-mdc-button-touch-target {
  width: 16px;
  height: 16px;
}
.app-pane .app-tabs-bar .app-tabs .app-tab .tab-close mat-icon {
  width: 14px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
}
.app-pane .app-tabs-bar .app-tabs .app-tab .tab-close:hover {
  opacity: 1;
}
.app-pane .app-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}
.app-pane .app-content .app-instance {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  flex-direction: column;
}
.app-pane .app-content .app-instance.active {
  display: flex;
}
.app-pane .app-content .app-instance > * {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.resize-divider {
  height: 6px;
  cursor: ns-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--border-color, rgba(128, 128, 128, 0.2));
  transition: background-color 0.15s ease;
}
.resize-divider:hover {
  background-color: var(--primary-color, #1976d2);
}
.resize-divider .divider-handle {
  width: 32px;
  height: 4px;
  border-radius: 2px;
  background-color: var(--text-secondary, rgba(128, 128, 128, 0.5));
}
.resize-divider:hover .divider-handle {
  background-color: white;
}

.chat-area {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  min-height: 0;
}
.chat-area.full-height {
  height: 100% !important;
}
.chat-area.hidden {
  height: 0 !important;
  min-height: 0 !important;
  overflow: hidden;
  flex: 0 !important;
}
.chat-area .chat-header-bar {
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  min-height: 28px;
  background-color: var(--surface-color, rgba(128, 128, 128, 0.05));
  border-bottom: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));
  flex-shrink: 0;
}
.chat-area .chat-header-bar > .pane-toggle-btn {
  margin-right: 0.25rem;
}
.chat-area .chat-header-bar .chat-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary, rgba(128, 128, 128, 0.8));
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.chat-area .chat-header-bar .close-chat-btn {
  width: 24px;
  height: 24px;
  padding: 0;
  opacity: 0.6;
  transition: opacity 0.15s ease;
}
.chat-area .chat-header-bar .close-chat-btn mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}
.chat-area .chat-header-bar .close-chat-btn:hover {
  opacity: 1;
}
.chat-area .chat-expand-bar {
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  min-height: 28px;
  background-color: var(--surface-color, rgba(128, 128, 128, 0.05));
  border-bottom: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));
}
.chat-area .chat-expand-bar .show-apps-btn {
  width: 24px;
  height: 24px;
  padding: 0;
}
.chat-area .chat-expand-bar .show-apps-btn mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}
.chat-area .chat-expand-bar .apps-hidden-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-secondary, rgba(128, 128, 128, 0.8));
  margin-left: 0.25rem;
}

.show-chat-bar {
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  min-height: 28px;
  background-color: var(--surface-color, rgba(128, 128, 128, 0.05));
  border-top: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));
  flex-shrink: 0;
}
.show-chat-bar .show-chat-btn {
  width: 24px;
  height: 24px;
  padding: 0;
}
.show-chat-bar .show-chat-btn mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}
.show-chat-bar .chat-hidden-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-secondary, rgba(128, 128, 128, 0.8));
  margin-left: 0.25rem;
}

.collapsed-pane-bar {
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  min-height: 28px;
  background-color: var(--surface-color, rgba(128, 128, 128, 0.05));
  flex-shrink: 0;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.collapsed-pane-bar:hover {
  background-color: var(--hover-color, rgba(128, 128, 128, 0.1));
}
.collapsed-pane-bar.top {
  border-bottom: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));
}
.collapsed-pane-bar.bottom {
  border-top: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.collapsed-pane-bar .restore-pane-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  opacity: 0.7;
}
.collapsed-pane-bar .collapsed-pane-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-secondary, rgba(128, 128, 128, 0.8));
  margin-left: 0.25rem;
}

.pane-toggle-btn {
  width: 24px;
  height: 24px;
  padding: 0;
  opacity: 0.6;
  transition: opacity 0.15s ease;
}
.pane-toggle-btn mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}
.pane-toggle-btn:hover {
  opacity: 1;
}

.session-button {
  --session-button-size: 24px;
  --session-icon-size: 18px;
  width: var(--session-button-size, 48px);
  height: var(--session-button-size, 48px);
  padding: 0px;
  border-radius: 0.5rem;
}
.session-button mat-icon {
  width: var(--session-icon-size, 24px);
  height: var(--session-icon-size, 24px);
  line-height: var(--session-icon-size, 24px);
  font-size: var(--session-icon-size, 24px);
}
.session-button ::ng-deep .mat-mdc-button-persistent-ripple {
  border-radius: 0.5rem;
}
.session-button ::ng-deep .mat-mdc-button-touch-target {
  width: var(--session-button-size, 48px);
  height: var(--session-button-size, 48px);
}

textarea {
  max-height: 200px;
}

/* Control visibility of menubar elements based on isFullScreen attribute */
:host:not([isfullscreen=true]) .header-bar .right.section {
  display: none !important;
}

:host([isfullscreen=true]) .header-bar .right.section {
  display: flex;
}

/* Always-present actions toolbar - switches between individual and bulk actions */
.actions-toolbar {
  min-height: 48px;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--border-color, #e0e0e0);
  background-color: var(--surface-color, #f5f5f5);
  display: flex;
  align-items: center;
}
.actions-toolbar .individual-actions {
  width: 100%;
}
.actions-toolbar .individual-actions .actions-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.actions-toolbar .individual-actions .actions-content .action-hint {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-secondary, #666);
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 0.5rem;
}
.actions-toolbar .individual-actions .actions-content .individual-buttons {
  display: flex;
  gap: 0.25rem;
  flex-shrink: 0;
}
.actions-toolbar .bulk-actions-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.actions-toolbar .bulk-actions-content .selection-count {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-secondary, #666);
}
.actions-toolbar .bulk-actions-content .bulk-actions {
  display: flex;
  gap: 0.25rem;
}

/* Enhanced chat history list with consistent heights */
.chat-history-list li {
  min-height: 25px;
  max-height: 25px;
}
.chat-history-list li .session-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.chat-history-list li.selection-mode {
  -webkit-user-select: none;
          user-select: none;
}
.chat-history-list li.selection-mode:hover:not(.selected) {
  background-color: var(--hover-color, rgba(0, 0, 0, 0.04));
}
.chat-history-list li:not(.selection-mode):hover {
  background-color: var(--hover-color, rgba(0, 0, 0, 0.04));
}

/* Enhanced button row layout */
.chat-history-container .button-row {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  /* Invisible placeholder for consistent spacing */
  /* Session action area - right side for both checkboxes and action buttons */
}
.chat-history-container .button-row button:last-child {
  margin-left: auto;
}
.chat-history-container .button-row .session-placeholder {
  width: 24px;
  height: 24px;
}
.chat-history-container .button-row .session-action-area {
  width: 24px;
  margin-left: 0.5rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chat-history-container .button-row .session-action-area .session-checkbox {
  margin: 0;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chat-history-container .button-row .session-action-area .session-checkbox ::ng-deep .mat-mdc-checkbox {
  height: 24px;
}
.chat-history-container .button-row .session-action-area .session-checkbox ::ng-deep .mat-mdc-checkbox .mdc-checkbox {
  display: flex;
  align-items: center;
  padding: 0;
}
.chat-history-container .button-row .session-action-area .session-checkbox ::ng-deep .mat-mdc-checkbox .mdc-form-field {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
}
.chat-history-container .button-row .session-action-area .session-checkbox ::ng-deep .mat-checkbox-inner-container {
  width: 16px;
  height: 16px;
  margin: 0;
}
.chat-history-container .button-row .session-action-area .session-button {
  --session-button-size: 24px;
  --session-icon-size: 18px;
  width: var(--session-button-size);
  height: var(--session-button-size);
  padding: 0;
  margin: 0;
  border-radius: 0.5rem;
}
.chat-history-container .button-row .session-action-area .session-button mat-icon {
  width: var(--session-icon-size);
  height: var(--session-icon-size);
  line-height: var(--session-icon-size);
  font-size: var(--session-icon-size);
}

/* Combined agent/session selector - mobile only */
.combined-selector-mobile {
  display: none; /* Hidden by default, shown on mobile via media query */
  flex: 1;
  min-width: 0;
  max-width: 100%;
  padding: 4px 8px;
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  font-size: 13px;
}
.combined-selector-mobile .combined-selector-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  text-align: left;
}
.combined-selector-mobile .combined-selector-text .agent-badge {
  font-size: 10px;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.combined-selector-mobile .combined-selector-text .session-name {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.combined-selector-mobile mat-icon {
  flex-shrink: 0;
}

/* Styling for the combined selector menu panel */
::ng-deep .combined-selector-panel {
  max-height: 70vh;
  min-width: 280px;
}
::ng-deep .combined-selector-panel .selector-header {
  font-weight: 600;
  background-color: rgba(0, 0, 0, 0.04);
}
::ng-deep .combined-selector-panel .selector-header .current-agent-header {
  font-weight: 600;
}
::ng-deep .combined-selector-panel .timeblock-label {
  padding: 8px 16px 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.6;
}
::ng-deep .combined-selector-panel .session-menu-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::ng-deep .combined-selector-panel .active-session,
::ng-deep .combined-selector-panel .active-agent {
  background-color: rgba(var(--primary-color-rgb, 25, 118, 210), 0.12);
  font-weight: 600;
}
::ng-deep .combined-selector-panel .no-sessions-hint {
  padding: 12px 16px;
  font-size: 13px;
  opacity: 0.6;
  font-style: italic;
}
::ng-deep .combined-selector-panel .agent-menu-item {
  display: flex;
  align-items: center;
  padding: 0 16px;
  min-height: 48px;
  cursor: pointer;
  gap: 16px;
}
::ng-deep .combined-selector-panel .agent-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
::ng-deep .combined-selector-panel .agent-menu-item mat-icon {
  flex-shrink: 0;
  color: var(--text-secondary, rgba(0, 0, 0, 0.54));
}
::ng-deep .combined-selector-panel .agent-menu-item span {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Header status chips - unified styling for session ID, token status, usage */
.header-chips {
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-chip {
  font-family: "SF Mono", "Monaco", "Inconsolata", "Roboto Mono", monospace;
  font-size: 0.7rem;
  letter-spacing: 0.3px;
  padding: 3px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: opacity 0.15s ease, background-color 0.15s ease;
  line-height: 1.2;
}
.header-chip mat-icon {
  font-size: 12px;
  width: 12px;
  height: 12px;
}
.header-chip .chip-label {
  opacity: 0.7;
}
.header-chip:hover {
  opacity: 0.85;
}
.header-chip.chip-neutral {
  background-color: rgba(128, 128, 128, 0.15);
  color: rgba(128, 128, 128, 0.9);
}
.header-chip.chip-neutral mat-icon {
  opacity: 0.8;
}
.header-chip.chip-neutral:hover {
  background-color: rgba(128, 128, 128, 0.25);
}
.header-chip.chip-success {
  background-color: rgba(76, 175, 80, 0.15);
  color: #4caf50;
}
.header-chip.chip-success mat-icon {
  color: #4caf50;
}
.header-chip.chip-warning {
  background-color: rgba(255, 152, 0, 0.15);
  color: #ff9800;
}
.header-chip.chip-warning mat-icon {
  color: #ff9800;
}
.header-chip.chip-error {
  background-color: rgba(244, 67, 54, 0.15);
  color: #f44336;
}
.header-chip.chip-error mat-icon {
  color: #f44336;
}
.header-chip.chip-refreshing {
  background-color: rgba(128, 128, 128, 0.15);
  color: rgba(128, 128, 128, 0.9);
}
.header-chip.chip-refreshing mat-icon.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* Tooltip styling for multiline content */
::ng-deep .multiline-tooltip .mdc-tooltip__surface {
  white-space: pre-line !important;
  max-width: 280px !important;
  text-align: left !important;
}

@container chat (max-width: 500px) {
  .header-chip .chip-session-id {
    display: none;
  }
  .header-chip .chip-label {
    display: none;
  }
}
@container chat (max-width: 700px) {
  .chat-history-container {
    display: none !important;
  }
  .sidebar-resize-divider {
    display: none !important;
  }
  .combined-selector-mobile {
    display: flex !important;
    width: 100% !important;
    max-width: none !important;
  }
  .combined-selector-mobile ::ng-deep .mdc-button__label {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .desktop-only {
    display: none !important;
  }
  .mobile-only {
    display: flex !important;
  }
  .header-chips.desktop-only {
    display: flex !important;
  }
  .header-chip {
    padding: 3px 5px;
    gap: 0;
  }
  .header-chip > span {
    display: none;
  }
  .header-bar .left.section {
    gap: 0;
    width: 100%;
  }
  .user-input {
    right: 0;
    padding-bottom: 0;
  }
  .user-input .prompt-box {
    padding: 10px 0.5rem 0;
    max-width: 100%;
  }
  .user-input ::ng-deep .mat-mdc-form-field-subscript-wrapper {
    display: none;
  }
  .user-input ::ng-deep .mat-mdc-form-field-bottom-align {
    display: none;
  }
  .user-input ::ng-deep .mdc-text-field--filled {
    padding-bottom: 0;
  }
  .user-input ::ng-deep .mat-mdc-form-field-infix {
    padding-bottom: 4px;
  }
  .main-chat-container,
  .content,
  app-chat-screen {
    overflow-x: hidden;
    box-sizing: border-box;
  }
  ::ng-deep pre,
  ::ng-deep code,
  ::ng-deep .tool-input,
  ::ng-deep .tool-output {
    max-width: 100% !important;
    overflow-x: auto !important;
    word-break: break-word !important;
  }
}
@container chat (max-width: 400px) {
  .agent-selector {
    max-width: 80px;
  }
  .header-bar .right.section {
    gap: 2px;
  }
  .user-input .input-actions {
    margin-left: 4px;
    margin-right: 4px;
    gap: 2px;
  }
  .pins-pane {
    display: none !important;
  }
  .pins-resize-divider {
    display: none !important;
  }
}
/* Desktop-only elements (hidden in compact container mode AND on mobile) */
.desktop-only {
  display: flex;
}

/* Mobile-only elements (hidden on desktop, shown in compact mode and on mobile) */
.mobile-only {
  display: none;
}

/* Responsive breakpoints for chat widget in full-screen mode */
/* Note: Angular sets isfullscreen="true" as a string attribute */
@media (max-width: 768px) {
  :host([isfullscreen=true]) .chat-history-container {
    display: none !important;
  }
  :host([isfullscreen=true]) .combined-selector-mobile {
    display: flex !important;
  }
  :host([isfullscreen=true]) .desktop-only {
    display: none !important;
  }
  :host([isfullscreen=true]) .mobile-only {
    display: flex !important;
  }
  :host([isfullscreen=true]) .header-bar .left.section {
    gap: 4px;
  }
  :host([isfullscreen=true]) .header-bar .right.section {
    gap: 2px;
  }
  :host([isfullscreen=true]) .main-chat-container {
    padding: 0;
    padding-bottom: 0 !important;
    overflow: hidden;
  }
  :host([isfullscreen=true]) .user-input {
    padding-top: 5px;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
  :host([isfullscreen=true]) .chat-container,
  :host([isfullscreen=true]) .gridster-item-content {
    height: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  :host([isfullscreen=true]) .main-chat-container,
  :host([isfullscreen=true]) .content,
  :host([isfullscreen=true]) app-chat-screen,
  :host([isfullscreen=true]) ::ng-deep .messages-container,
  :host([isfullscreen=true]) ::ng-deep .message,
  :host([isfullscreen=true]) ::ng-deep .message-content,
  :host([isfullscreen=true]) ::ng-deep app-tool-message,
  :host([isfullscreen=true]) ::ng-deep .tool-message {
    max-width: 100vw !important;
    overflow-x: hidden !important;
    box-sizing: border-box !important;
  }
  :host([isfullscreen=true]) ::ng-deep pre,
  :host([isfullscreen=true]) ::ng-deep code,
  :host([isfullscreen=true]) ::ng-deep .tool-input,
  :host([isfullscreen=true]) ::ng-deep .tool-output {
    max-width: 100% !important;
    overflow-x: auto !important;
    word-break: break-word !important;
  }
}
/* Even narrower screens - make agent selector more compact */
@media (max-width: 480px) {
  :host([isfullscreen=true]) .agent-selector {
    max-width: 80px;
  }
}
/* Responsive input area for narrow screens in full-screen mode */
@media (max-width: 768px) {
  :host([isfullscreen=true]) .user-input {
    width: 100%;
  }
  :host([isfullscreen=true]) .user-input .prompt-box {
    padding: 0 !important;
    max-width: 100% !important;
    width: 100%;
    margin: 0;
  }
  :host([isfullscreen=true]) .user-input .input-actions {
    margin-left: 4px;
    margin-right: 4px;
    gap: 2px;
  }
  :host([isfullscreen=true]) .user-input .input-actions .upload-btn,
  :host([isfullscreen=true]) .user-input .input-actions .voice-btn {
    width: 28px;
    height: 28px;
  }
  :host([isfullscreen=true]) .user-input .input-actions .upload-btn mat-icon,
  :host([isfullscreen=true]) .user-input .input-actions .voice-btn mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  :host([isfullscreen=true]) .user-input .form-field {
    width: 100%;
    overflow: visible !important;
  }
  :host([isfullscreen=true]) .user-input .form-field ::ng-deep .mdc-text-field--filled,
  :host([isfullscreen=true]) .user-input .form-field ::ng-deep .mat-mdc-text-field-wrapper {
    border-radius: 0 !important;
    padding-left: 0 !important;
    padding-right: 48px !important;
    overflow: visible !important;
  }
  :host([isfullscreen=true]) .user-input .form-field ::ng-deep .mat-mdc-form-field-icon-suffix {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
  }
  :host([isfullscreen=true]) .user-input .form-field ::ng-deep .mat-mdc-form-field-infix {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    min-height: unset !important;
  }
  :host([isfullscreen=true]) .user-input .form-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
    display: none !important;
  }
  :host([isfullscreen=true]) .user-input textarea {
    min-height: 60px !important;
    max-height: 120px !important;
    overflow-y: auto !important;
  }
  :host([isfullscreen=true]) .user-input textarea::placeholder {
    color: transparent !important;
    opacity: 0 !important;
  }
  :host([isfullscreen=true]) .user-input .input-actions {
    align-self: center;
  }
  :host([isfullscreen=true]) .user-input .form-field.recording ::ng-deep .mdc-text-field--filled {
    background-color: #f44336 !important;
  }
  :host([isfullscreen=true]) .user-input .form-field.recording textarea {
    color: white !important;
  }
  :host([isfullscreen=true]) .user-input .form-field.recording textarea::placeholder {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  :host([isfullscreen=true]) .user-input .form-field {
    position: relative;
  }
  :host([isfullscreen=true]) .user-input .form-field .mobile-placeholder {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: var(--text-secondary, rgba(128, 128, 128, 0.8));
    font-size: 16px;
    z-index: 1;
    transition: opacity 0.15s ease;
  }
  :host([isfullscreen=true]) .user-input .form-field .mobile-placeholder.recording {
    color: rgba(255, 255, 255, 0.9);
  }
}
@media (max-width: 480px) {
  :host([isfullscreen=true]) .user-input .input-actions {
    margin-left: 2px;
    margin-right: 2px;
  }
  :host([isfullscreen=true]) .user-input .input-actions .upload-btn,
  :host([isfullscreen=true]) .user-input .input-actions .voice-btn {
    width: 26px;
    height: 26px;
  }
  :host([isfullscreen=true]) .user-input .input-actions .upload-btn mat-icon,
  :host([isfullscreen=true]) .user-input .input-actions .voice-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
}
.header-chip.chip-active {
  background-color: rgba(25, 118, 210, 0.15) !important;
  color: var(--tool-accent, #1976d2) !important;
}
.header-chip.chip-active mat-icon {
  color: var(--tool-accent, #1976d2) !important;
}

.pins-resize-divider {
  width: 4px;
  cursor: ew-resize;
  background-color: var(--resize-divider-color, transparent);
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}
.pins-resize-divider:hover {
  background-color: var(--primary-color, #1976d2);
  opacity: 0.5;
}

.pins-pane {
  display: flex;
  height: 100%;
  min-width: 15%;
  max-width: 50%;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
}
.pins-pane .pins-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  flex-shrink: 0;
}
.pins-pane .pins-header .pins-header-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0.7;
}
.pins-pane .pins-header .pins-title {
  font-weight: 600;
  font-size: 14px;
}
.pins-pane .pins-header .flex-spacer {
  flex: 1;
}
.pins-pane .pins-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}
.pins-pane .pin-card {
  padding: 10px 12px;
  transition: background 0.1s ease;
}
.pins-pane .pin-card.kg-card {
  height: 158px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.pins-pane .pin-card.kg-card .pin-card-header {
  flex-shrink: 0;
}
.pins-pane .pin-card.kg-card .pin-card-content {
  max-height: none !important;
  flex: 1;
}
.pins-pane .pin-card .pin-card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.pins-pane .pin-card .pin-card-header .flex-spacer {
  flex: 1;
}
.pins-pane .pin-card .pin-card-header .pin-role-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.pins-pane .pin-card .pin-card-header .pin-timestamp {
  font-size: 11px;
}
.pins-pane .pin-card .pin-card-header .jump-btn,
.pins-pane .pin-card .pin-card-header .unpin-btn {
  --square-button-size: 24px;
  --square-icon-size: 14px;
  transition: opacity 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pins-pane .pin-card .pin-card-header .jump-btn mat-icon,
.pins-pane .pin-card .pin-card-header .unpin-btn mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.pins-pane .pin-card .pin-card-header .jump-btn {
  opacity: 0.5;
}
.pins-pane .pin-card .pin-card-header .jump-btn:hover {
  opacity: 1;
}
.pins-pane .pin-card .pin-card-header .unpin-btn {
  opacity: 0.5;
}
.pins-pane .pin-card .pin-card-header .unpin-btn:hover {
  opacity: 1;
}
.pins-pane .pin-card .pin-card-content {
  font-size: 13px;
  line-height: 1.5;
  overflow: hidden;
}
.pins-pane .pin-card .pin-card-content:not(.expanded) {
  max-height: 120px;
  mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
  -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
}
.pins-pane .pin-card .pin-card-content ::ng-deep h1, .pins-pane .pin-card .pin-card-content ::ng-deep h2, .pins-pane .pin-card .pin-card-content ::ng-deep h3, .pins-pane .pin-card .pin-card-content ::ng-deep h4 {
  font-size: 14px;
  margin: 4px 0;
}
.pins-pane .pin-card .pin-card-content ::ng-deep p {
  margin: 4px 0;
}
.pins-pane .pin-card .pin-card-content ::ng-deep pre {
  font-size: 11px;
  padding: 6px;
  overflow-x: auto;
}
.pins-pane .pin-card .pin-card-content ::ng-deep ul, .pins-pane .pin-card .pin-card-content ::ng-deep ol {
  padding-left: 20px;
  margin: 4px 0;
}
.pins-pane .pin-card .pin-card-content ::ng-deep code {
  font-size: 12px;
}
.pins-pane .pin-card .pin-card-content ::ng-deep app-tool-message {
  display: block;
}
.pins-pane .pin-card .show-more-btn {
  font-size: 11px;
  padding: 0 4px;
  min-height: 24px;
  line-height: 24px;
}
.pins-pane .pins-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  opacity: 0.5;
  font-size: 13px;
}
.pins-pane .pins-graph-container {
  flex: 1;
  overflow: hidden;
  position: relative;
}
.pins-pane .pins-graph-container app-knowledge-graph-widget {
  display: block;
  width: 100%;
  height: 100%;
}
.pins-pane .pins-graph-container app-knowledge-graph-widget ::ng-deep .widget-body {
  height: 100%;
}
.pins-pane .pins-node-count {
  font-size: 11px;
  opacity: 0.6;
  margin-left: -4px;
}
.pins-pane .kg-msg-loading {
  font-size: 12px;
  opacity: 0.5;
  padding: 4px 0;
}
.pins-pane .kg-msg-loading .shimmer-lines .shimmer-line {
  height: 10px;
  border-radius: 3px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.04) 25%, rgba(255, 255, 255, 0.08) 50%, rgba(255, 255, 255, 0.04) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 6px;
}
.pins-pane .kg-msg-loading .shimmer-lines .shimmer-line:nth-child(1) {
  width: 90%;
}
.pins-pane .kg-msg-loading .shimmer-lines .shimmer-line:nth-child(2) {
  width: 70%;
}
.pins-pane .kg-msg-loading .shimmer-lines .shimmer-line:nth-child(3) {
  width: 50%;
}
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.pins-pane .kg-msg-excerpt {
  font-size: 12px;
  opacity: 0.6;
  line-height: 1.4;
  font-style: italic;
}
.pins-pane .kg-filter-bar {
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 8px;
  gap: 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.pins-pane .kg-filter-bar .kg-filter-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.4;
}
.pins-pane .kg-filter-bar .kg-filter-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: inherit;
  font-size: 12px;
  padding: 4px 0;
}
.pins-pane .kg-filter-bar .kg-filter-input::placeholder {
  opacity: 0.4;
}
.pins-pane .kg-filter-bar .kg-filter-count {
  font-size: 11px;
  opacity: 0.5;
  white-space: nowrap;
}
.pins-pane .kg-filter-bar .kg-filter-clear {
  font-size: 14px;
  width: 14px;
  height: 14px;
  cursor: pointer;
  opacity: 0.4;
}
.pins-pane .kg-filter-bar .kg-filter-clear:hover {
  opacity: 0.8;
}
.pins-pane .kg-no-results {
  padding: 16px 12px;
  font-size: 12px;
  opacity: 0.5;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/chat-widget/chat-widget.component.scss","webpack://./src/styles/_breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,mJACE;EAWF,YAAA;EACA,gBAAA;AAZF;;AAeA;EACE,WAAA;AAZF;;AAeA;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,oBAAA;AAZF;AAcE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAZJ;;AAiBA;EACE,YAAA;AAdF;;AAiBA;EACE,YAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AAdF;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAdJ;AAgBI;EACE,OAAA;EACA,gBAAA;AAdN;AAiBI;EACE,iBAAA;EACA,cAAA;AAfN;AAmBE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,sCAAA;EACA,4BAAA;EACA,aAAA;EACA,4CACE;AApBJ;AAuBE;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,eAAA;AAtBJ;AAyBE;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AAvBJ;;AA2BA,6DAAA;AAEA;EACE,0BAAA;EAEA,sCAAA;EACA,uCAAA;EACA,oFAAA;EACA,qBAAA;AA1BF;AA4BE;EACE,oCAAA;EACA,qCAAA;EACA,0CAAA;EACA,wCAAA;AA1BJ;AA6BE;EACE,qBAAA;AA3BJ;AA8BE;EACE,sCAAA;EACA,uCAAA;AA5BJ;;AAgCA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AA7BF;AA+BE;EACE,YAAA;EACA,WAAA;EACA,eAAA;AA7BJ;AAgCE;EACE,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AA9BJ;AAgCI;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AA9BN;AAgCM;EACE,sCAAA;AA9BR;;AAoCA;EACE,oBAAA;EAGA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,4DAAA;AAnCF;AAqCE;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;AAnCJ;ACtKI;EDqMF;IAOI,gBAAA;IACA,kBAAA;EAlCJ;AACF;AC5KI;EDqMF;IAYI,gBAAA;IACA,kBAAA;EAjCJ;AACF;AClLI;EDqMF;IAiBI,gBAAA;IACA,eAAA;EAhCJ;AACF;AAmCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;AAjCJ;AAmCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,2DAAA;AAjCN;AAmCM;EACE,UAAA;EACA,qCAAA;AAjCR;AAoCM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlCR;AAsCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,6EAAA;AApCN;AAsCM;EACE,UAAA;EACA,qCAAA;AApCR;AAuCM;EACE,UAAA;EACA,yBAAA;EACA,YAAA;EACA,oDAAA;AArCR;AAwCM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtCR;AA2CE;EACE;IACE,0CAAA;EAzCJ;EA2CE;IACE,0CAAA;EAzCJ;AACF;AA4CE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA1CJ;AA4CI;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AA1CN;AA6CI;EACE,kBAAA;EACA,MAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;AA3CN;AA6CM;EACE,8BAAA;AA3CR;AA8CM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA5CR;AAiDE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AA/CJ;;AAmDA,kEAAA;AACA;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AAhDF;AAkDE;EACE,YAAA;AAhDJ;AAmDE;EACE,eAAA;AAjDJ;AAoDE;EACE,iBAAA;AAlDJ;;AAsDA;EACE,aAAA;EACA,sCAAA;EACA,WAAA;EACA,mBAAA;AAnDF;AAqDE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;AAnDJ;AAsDE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AApDJ;;AAwDA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;EACA,2BAAA;EACA,uBAAA;AArDF;AAyDE;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;AAvDJ;AA0DE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAxDJ;AA2DI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;AAzDN;AA8DE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AA5DJ;AA8DI;EACE,OAAA;EACA,YAAA;AA5DN;AA8DM;EACE,aAAA;AA5DR;AA+DM;EACE,iBAAA;AA7DR;AAgEM;EACE,mBAAA;EACA,sBAAA;EACA,iBAAA;AA9DR;AAiEM;EACE,oBAAA;AA/DR;AAkEM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;AAhER;AAmEM;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAjER;AAoEM;EACE,oBAAA;EACA,cAAA;AAlER;AAuEI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AArEN;AAuEM;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AArER;AAwEM;EACE,WAAA;EACA,YAAA;AAtER;AA0EM;EACE,0EAAA;AAxER;AA8EM;EACE,oBAAA;EACA,gBAAA;EACA,+DAAA;EACA,mBAAA;AA5ER;AA+EM;EACE,OAAA;AA7ER;AAkFE;EACE,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,OAAA;AAhFJ;AAmFE;EACE,kBAAA;AAjFJ;AAmFI;EACE,gBAAA;EACA,MAAA;AAjFN;AAmFM;EACE,8BAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;AAjFR;;AAuFA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AApFF;AAsFE;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,eAAA;AApFJ;;AA6FA;EACE,UAAA;EACA,iBAAA;EACA,0DAAA;EACA,yDAAA;EACA,cAAA;AA1FF;AA4FE;EACE,+CAAA;EACA,YAAA;AA1FJ;AA8FE;EACE,UAAA;EACA,gBAAA;EACA,YAAA;AA5FJ;AA8FI;EACE,UAAA;EACA,UAAA;AA5FN;;AAqGA;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mEAAA;AAlGF;AAoGE;EACE,wBAAA;AAlGJ;AAoGI;EACE,gBAAA;EACA,mBAAA;EACA,sDAAA;AAlGN;AAsGE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AApGJ;AAsGI;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,eAAA;EACA,uCAAA;AApGN;AAsGM;EACE,yDAAA;AApGR;AAuGM;EACE,yFAAA;AArGR;AAwGM;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,oCAAA;AAtGR;AAyGM;EACE,OAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAvGR;AA0GM;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,8BAAA;AAxGR;AA0GQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAxGV;AA4GM;EACE,YAAA;AA1GR;AA4GQ;EACE,UAAA;AA1GV;;AAqHA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AAlHF;;AAqHA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAlHF;AAoHE;EACE,oBAAA;EACA,wBAAA;EACA,gBAAA;AAlHJ;AAqHE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iEAAA;EACA,uEAAA;AAnHJ;AAqHI;EACE,qBAAA;AAnHN;AAsHI;EACE,aAAA;EACA,OAAA;EACA,gBAAA;EACA,QAAA;AApHN;AAsHM;EACE,WAAA;AApHR;AAuHM;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,oCAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,yDAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,gDAAA;AArHR;AAuHQ;EACE,yDAAA;EACA,+CAAA;AArHV;AAwHQ;EACE,gEAAA;EACA,2DAAA;EACA,cAAA;AAtHV;AAyHQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;AAvHV;AA0HQ;EACE,sBAAA;EACA,cAAA;AAxHV;AA2HQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAzHV;AA2HU;EACE,WAAA;EACA,YAAA;AAzHZ;AA4HU;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AA1HZ;AA6HU;EACE,UAAA;AA3HZ;AAmIE;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAjIJ;AAmII;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AAjIN;AAmIM;EACE,aAAA;AAjIR;AAqIM;EACE,OAAA;EACA,aAAA;EACA,cAAA;AAnIR;;AAyIA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+DAAA;EACA,uCAAA;AAtIF;AAwIE;EACE,+CAAA;AAtIJ;AAyIE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iEAAA;AAvIJ;AA0IE;EACE,uBAAA;AAxIJ;;AA4IA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,aAAA;AAzIF;AA2IE;EACE,uBAAA;AAzIJ;AA4IE;EACE,oBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;AA1IJ;AA6IE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iEAAA;EACA,uEAAA;EACA,cAAA;AA3IJ;AA6II;EACE,qBAAA;AA3IN;AA8II;EACE,kBAAA;EACA,gBAAA;EACA,sDAAA;EACA,yBAAA;EACA,qBAAA;AA5IN;AA+II;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;AA7IN;AA+IM;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA7IR;AAgJM;EACE,UAAA;AA9IR;AAmJE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iEAAA;EACA,uEAAA;AAjJJ;AAmJI;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAjJN;AAmJM;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAjJR;AAqJI;EACE,kBAAA;EACA,gBAAA;EACA,sDAAA;EACA,oBAAA;AAnJN;;AAwJA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iEAAA;EACA,oEAAA;EACA,cAAA;AArJF;AAuJE;EACE,WAAA;EACA,YAAA;EACA,UAAA;AArJJ;AAuJI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AArJN;AAyJE;EACE,kBAAA;EACA,gBAAA;EACA,sDAAA;EACA,oBAAA;AAvJJ;;AA+JA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iEAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;AA5JF;AA8JE;EACE,8DAAA;AA5JJ;AA+JE;EACE,uEAAA;AA7JJ;AAgKE;EACE,oEAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AA9JJ;AAiKE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AA/JJ;AAkKE;EACE,kBAAA;EACA,gBAAA;EACA,sDAAA;EACA,oBAAA;AAhKJ;;AAqKA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;AAlKF;AAoKE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAlKJ;AAqKE;EACE,UAAA;AAnKJ;;AAuKA;EACE,2BAAA;EACA,yBAAA;EAEA,uCAAA;EACA,wCAAA;EACA,YAAA;EACA,qBAAA;AArKF;AAuKE;EACE,qCAAA;EACA,sCAAA;EACA,2CAAA;EACA,yCAAA;AArKJ;AAwKE;EACE,qBAAA;AAtKJ;AAyKE;EACE,uCAAA;EACA,wCAAA;AAvKJ;;AA2KA;EACE,iBAAA;AAxKF;;AA2KA,2EAAA;AAEE;EACE,wBAAA;AAzKJ;;AA8KE;EACE,aAAA;AA3KJ;;AAgLA,kFAAA;AACA;EACE,gBAAA;EACA,uBAAA;EACA,qDAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;AA7KF;AA+KE;EACE,WAAA;AA7KJ;AA+KI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA7KN;AA+KM;EACE,mBAAA;EACA,gBAAA;EACA,kCAAA;EACA,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AA7KR;AAgLM;EACE,aAAA;EACA,YAAA;EACA,cAAA;AA9KR;AAmLE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAjLJ;AAmLI;EACE,mBAAA;EACA,gBAAA;EACA,kCAAA;AAjLN;AAoLI;EACE,aAAA;EACA,YAAA;AAlLN;;AAuLA,uDAAA;AAEE;EAEE,gBAAA;EACA,gBAAA;AAtLJ;AAyLI;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;AAvLN;AA2LI;EACE,yBAAA;UAAA,iBAAA;AAzLN;AA2LM;EACE,yDAAA;AAzLR;AA8LI;EACE,yDAAA;AA5LN;;AAiMA,+BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EAOF,iDAAA;EAMA,4EAAA;AAzMA;AA+LE;EACE,iBAAA;AA7LJ;AAiMA;EACE,WAAA;EACA,YAAA;AA/LF;AAmMA;EACE,WAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjMF;AAmME;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjMJ;AAmMI;EACE,YAAA;AAjMN;AAmMM;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AAjMR;AAoMM;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AAlMR;AAsMI;EACE,WAAA;EACA,YAAA;EACA,SAAA;AApMN;AAwME;EAEE,2BAAA;EACA,yBAAA;EAEA,iCAAA;EACA,kCAAA;EACA,UAAA;EACA,SAAA;EACA,qBAAA;AAxMJ;AA0MI;EACE,+BAAA;EACA,gCAAA;EACA,qCAAA;EACA,mCAAA;AAxMN;;AA+MA,kDAAA;AACA;EACE,aAAA,EAAA,uDAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AA5MF;AA8ME;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AA5MJ;AA8MI;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;AA5MN;AA+MI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AA7MN;AAiNE;EACE,cAAA;AA/MJ;;AAmNA,iDAAA;AACA;EACE,gBAAA;EACA,gBAAA;AAhNF;AAkNE;EACE,gBAAA;EACA,qCAAA;AAhNJ;AAkNI;EACE,gBAAA;AAhNN;AAoNE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AAlNJ;AAqNE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAnNJ;AAsNE;;EAEE,oEAAA;EACA,gBAAA;AApNJ;AAuNE;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AArNJ;AAyNE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AAvNJ;AAyNI;EACE,qCAAA;AAvNN;AA0NI;EACE,cAAA;EACA,iDAAA;AAxNN;AA2NI;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAzNN;;AA8NA,8EAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA3NF;;AA8NA;EACE,yEAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,2DAAA;EACA,gBAAA;AA3NF;AA6NE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3NJ;AA8NE;EACE,YAAA;AA5NJ;AA+NE;EACE,aAAA;AA7NJ;AAiOE;EACE,2CAAA;EACA,+BAAA;AA/NJ;AAiOI;EACE,YAAA;AA/NN;AAkOI;EACE,2CAAA;AAhON;AAqOE;EACE,yCAAA;EACA,cAAA;AAnOJ;AAqOI;EACE,cAAA;AAnON;AAwOE;EACE,yCAAA;EACA,cAAA;AAtOJ;AAwOI;EACE,cAAA;AAtON;AA2OE;EACE,yCAAA;EACA,cAAA;AAzOJ;AA2OI;EACE,cAAA;AAzON;AA8OE;EACE,2CAAA;EACA,+BAAA;AA5OJ;AA8OI;EACE,kCAAA;AA5ON;;AAiPA;EACE;IAAO,uBAAA;EA7OP;EA8OA;IAAK,yBAAA;EA3OL;AACF;AA6OA,0CAAA;AACA;EACE,gCAAA;EACA,2BAAA;EACA,2BAAA;AA3OF;;AA+OA;EACE;IACE,aAAA;EA5OF;EA+OA;IACE,aAAA;EA7OF;AACF;AAoPA;EAEE;IACE,wBAAA;EAnPF;EAuPA;IACE,wBAAA;EArPF;EAyPA;IACE,wBAAA;IACA,sBAAA;IACA,0BAAA;EAvPF;EA0PE;IACE,WAAA;IACA,aAAA;IACA,mBAAA;EAxPJ;EA6PA;IACE,wBAAA;EA3PF;EA8PA;IACE,wBAAA;EA5PF;EAgQA;IACE,wBAAA;EA9PF;EAiQA;IACE,gBAAA;IACA,MAAA;EA/PF;EAiQE;IACE,aAAA;EA/PJ;EAmQA;IACE,MAAA;IACA,WAAA;EAjQF;EAqQA;IACE,QAAA;IACA,iBAAA;EAnQF;EAqQE;IACE,sBAAA;IACA,eAAA;EAnQJ;EAuQE;IACE,aAAA;EArQJ;EAwQE;IACE,aAAA;EAtQJ;EAyQE;IACE,iBAAA;EAvQJ;EA0QE;IACE,mBAAA;EAxQJ;EA6QA;;;IAGE,kBAAA;IACA,sBAAA;EA3QF;EA+QA;;;;IAIE,0BAAA;IACA,2BAAA;IACA,iCAAA;EA7QF;AACF;AAiRA;EACE;IACE,eAAA;EA/QF;EAkRA;IACE,QAAA;EAhRF;EAmRA;IACE,gBAAA;IACA,iBAAA;IACA,QAAA;EAjRF;EAqRA;IACE,wBAAA;EAnRF;EAsRA;IACE,wBAAA;EApRF;AACF;AAuRA,2EAAA;AACA;EACE,aAAA;AArRF;;AAwRA,kFAAA;AACA;EACE,aAAA;AArRF;;AAyRA,+DAAA;AACA,iEAAA;AACA;EAEI;IACE,wBAAA;EAvRJ;EA2RE;IACE,wBAAA;EAzRJ;EA6RE;IACE,wBAAA;EA3RJ;EA+RE;IACE,wBAAA;EA7RJ;EAgSE;IACE,QAAA;EA9RJ;EAiSE;IACE,QAAA;EA/RJ;EAmSE;IACE,UAAA;IACA,4BAAA;IACA,gBAAA;EAjSJ;EAqSE;IACE,gBAAA;IACA,4BAAA;IACA,2BAAA;EAnSJ;EAuSE;;IAEE,uBAAA;IACA,qBAAA;IACA,oBAAA;EArSJ;EAySE;;;;;;;;IAQE,2BAAA;IACA,6BAAA;IACA,iCAAA;EAvSJ;EA2SE;;;;IAIE,0BAAA;IACA,2BAAA;IACA,iCAAA;EAzSJ;AACF;AA6SA,6DAAA;AACA;EAEI;IACE,eAAA;EA5SJ;AACF;AAgTA,iEAAA;AACA;EAEI;IACE,WAAA;EA/SJ;EAiTI;IACE,qBAAA;IACA,0BAAA;IACA,WAAA;IACA,SAAA;EA/SN;EAkTI;IACE,gBAAA;IACA,iBAAA;IACA,QAAA;EAhTN;EAkTM;;IAEE,WAAA;IACA,YAAA;EAhTR;EAkTQ;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA/SV;EAoTI;IACE,WAAA;IACA,4BAAA;EAlTN;EAqTM;;IAEE,2BAAA;IACA,0BAAA;IACA,8BAAA;IACA,4BAAA;EAnTR;EAuTM;IACE,kBAAA;IACA,UAAA;IACA,QAAA;IACA,2BAAA;EArTR;EAyTM;IACE,2BAAA;IACA,8BAAA;IACA,4BAAA;EAvTR;EA2TM;IACE,wBAAA;EAzTR;EA8TI;IACE,2BAAA;IACA,4BAAA;IACA,2BAAA;EA5TN;EA+TM;IACE,6BAAA;IACA,qBAAA;EA7TR;EAkUI;IACE,kBAAA;EAhUN;EAqUM;IACE,oCAAA;EAnUR;EAsUM;IACE,uBAAA;EApUR;EAsUQ;IACE,0CAAA;EApUV;EA0UI;IACE,kBAAA;EAxUN;EA0UM;IACE,kBAAA;IACA,UAAA;IACA,QAAA;IACA,2BAAA;IACA,oBAAA;IACA,sDAAA;IACA,eAAA;IACA,UAAA;IACA,8BAAA;EAxUR;EA0UQ;IACE,+BAAA;EAxUV;AACF;AA+UA;EAGM;IACE,gBAAA;IACA,iBAAA;EA/UN;EAiVM;;IAEE,WAAA;IACA,YAAA;EA/UR;EAiVQ;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA9UV;AACF;AAsVA;EACE,qDAAA;EACA,6CAAA;AApVF;AAsVE;EACE,6CAAA;AApVJ;;AAyVA;EACE,UAAA;EACA,iBAAA;EACA,0DAAA;EACA,uCAAA;EACA,cAAA;AAtVF;AAwVE;EACE,+CAAA;EACA,YAAA;AAtVJ;;AA2VA;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAxVF;AA2VE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;AAzVJ;AA2VI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAzVN;AA4VI;EACE,gBAAA;EACA,eAAA;AA1VN;AA6VI;EACE,OAAA;AA3VN;AA+VE;EACE,OAAA;EACA,gBAAA;EACA,cAAA;AA7VJ;AAgWE;EACE,kBAAA;EACA,gCAAA;AA9VJ;AAgWI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AA9VN;AAgWM;EAAmB,cAAA;AA7VzB;AA8VM;EAAoB,2BAAA;EAA6B,OAAA;AA1VvD;AA6VI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA3VN;AA6VM;EACE,OAAA;AA3VR;AA8VM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA5VR;AA+VM;EACE,eAAA;AA7VR;AAgWM;;EAEE,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9VR;AAgWQ;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA7VV;AAiWM;EACE,YAAA;AA/VR;AAiWQ;EACE,UAAA;AA/VV;AAmWM;EACE,YAAA;AAjWR;AAmWQ;EACE,UAAA;AAjWV;AAsWI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AApWN;AAsWM;EACE,iBAAA;EACA,mEAAA;EACA,2EAAA;AApWR;AAyWQ;EAAiB,eAAA;EAAiB,aAAA;AArW1C;AAsWQ;EAAI,aAAA;AAnWZ;AAoWQ;EAAM,eAAA;EAAiB,YAAA;EAAc,gBAAA;AA/V7C;AAgWQ;EAAS,kBAAA;EAAoB,aAAA;AA5VrC;AA6VQ;EAAO,eAAA;AA1Vf;AA4VQ;EAAmB,cAAA;AAzV3B;AA6VI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AA3VN;AA+VE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AA7VJ;AAgWE;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;AA9VJ;AAgWI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AA9VN;AAiWQ;EACE,YAAA;AA/VV;AAqWE;EACE,eAAA;EACA,YAAA;EACA,iBAAA;AAnWJ;AAsWE;EACE,eAAA;EACA,YAAA;EACA,cAAA;AApWJ;AAuWM;EACE,YAAA;EACA,kBAAA;EACA,+HAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;AArWR;AAuWQ;EAAiB,UAAA;AApWzB;AAqWQ;EAAiB,UAAA;AAlWzB;AAmWQ;EAAiB,UAAA;AAhWzB;AAoWI;EACE;IAAK,2BAAA;EAjWT;EAkWI;IAAO,4BAAA;EA/VX;AACF;AAkWE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAhWJ;AAmWE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,kDAAA;AAjWJ;AAmWI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAjWN;AAoWI;EACE,OAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAlWN;AAoWM;EAAiB,YAAA;AAjWvB;AAoWI;EACE,eAAA;EACA,YAAA;EACA,mBAAA;AAlWN;AAqWI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAnWN;AAqWM;EAAU,YAAA;AAlWhB;AAsWE;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AApWJ","sourcesContent":["@import '../../../../styles/breakpoints';\n\n:host {\n  font-family:\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    'Open Sans',\n    'Helvetica Neue',\n    sans-serif;\n  min-width: 0; // Allow shrinking in flex context\n  overflow: hidden; // Contain children\n}\n\nmat-form-field {\n  width: 100%;\n}\n\n.chat-container {\n  flex: 1; // Fill remaining space after the titlebar (height varies by density)\n  min-height: 0; // Allow shrinking in flex context\n  display: flex;\n  flex-direction: row;\n  overflow: hidden; // Contain children\n  container-type: inline-size;\n  container-name: chat;\n\n  .main-chat-container {\n    flex-grow: 1;\n    min-width: 0; // Allow shrinking in flex context\n    display: flex;\n    flex-direction: column;\n    overflow: hidden; // Contain children\n  }\n}\n\n// Full-screen mode: no titlebar, so use full height\n:host([isfullscreen=\"true\"]) .chat-container {\n  height: 100%;\n}\n\n.content {\n  flex: 1 1 0%;\n  overflow: hidden;\n}\n\n.header-bar {\n  padding: 0.25rem;\n  display: flex;\n  z-index: 100;\n  position: relative;\n\n  .section {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    &.left {\n      flex: 1;\n      overflow: hidden;\n    }\n\n    &.right {\n      margin-left: auto;\n      flex-shrink: 0;\n    }\n  }\n\n  .chat-title {\n    margin: 0 0.75rem;\n    font-size: 1.125rem;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n  }\n\n  .model-selector {\n    box-sizing: border-box;\n    font-weight: 600;\n    font-size: 1.125rem;\n    width: 320px;\n    height: 2.5rem;\n    line-height: 1.75rem;\n    padding: 0.375rem 0.75rem;\n    border-radius: 0.5rem;\n    overflow: hidden;\n    align-items: center;\n    display: flex;\n    white-space: nowrap;\n    user-select: none;\n  }\n}\n\n.model-listing {\n  display: grid;\n  grid-template-columns: min-content 1fr;\n  grid-template-rows: 1fr 1rem;\n  gap: 0px 12px;\n  grid-template-areas:\n    'icon name'\n    'icon desc';\n\n  .model-icon {\n    margin: 0;\n    grid-area: icon;\n    width: 32px;\n    height: 32px;\n    align-self: center;\n  }\n\n  .model-name {\n    grid-area: name;\n  }\n\n  .model-description {\n    grid-area: desc;\n    font-size: 0.75rem;\n    line-height: 1rem;\n  }\n}\n\n/* pulling-models-info removed - replaced by agent selector */\n\n.square-button {\n  --square-button-size: 40px;\n\n  width: var(--square-button-size, 48px);\n  height: var(--square-button-size, 48px);\n  padding: calc((var(--square-button-size, 48px) - var(--square-icon-size, 24px)) / 2);\n  border-radius: 0.5rem;\n\n  mat-icon {\n    width: var(--square-icon-size, 24px);\n    height: var(--square-icon-size, 24px);\n    line-height: var(--square-icon-size, 24px);\n    font-size: var(--square-icon-size, 24px);\n  }\n\n  ::ng-deep .mat-mdc-button-persistent-ripple {\n    border-radius: 0.5rem;\n  }\n\n  ::ng-deep .mat-mdc-button-touch-target {\n    width: var(--square-button-size, 48px);\n    height: var(--square-button-size, 48px);\n  }\n}\n\n.new-convo {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .brand {\n    height: 48px;\n    width: 48px;\n    font-size: 48px;\n  }\n\n  .samples {\n    margin: 3rem 0.75rem 0;\n    max-width: 48rem;\n    gap: 1rem;\n    justify-content: center;\n    align-items: stretch;\n    flex-wrap: wrap;\n    max-width: 48rem;\n    display: flex;\n\n    .sample {\n      border: 1px solid;\n      border-radius: 1rem;\n      cursor: pointer;\n      color: inherit;\n      padding: 0.75rem 0.75rem 1rem;\n      font-size: 15px;\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n      text-align: left;\n      align-items: flex-start;\n\n      & > mat-icon {\n        font-family: 'Material Icons Outlined';\n      }\n    }\n  }\n}\n\n.user-input {\n  padding-bottom: 10px;\n  // Position absolute so textarea growth doesn't shrink the chat scroll\n  // container. Leaves room on the right for the chat scrollbar.\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 25px;\n  z-index: 10;\n  background: var(--chat-area-bg, var(--surface-color, white));\n\n  .prompt-box {\n    margin: 0 auto;\n    display: flex;\n    flex-grow: 1;\n    padding: 10px 0.75rem 0;\n\n    @include respond-to(xl) {\n      max-width: 48rem;\n      padding: 0 1.25rem;\n    }\n\n    @include respond-to(lg) {\n      max-width: 40rem;\n      padding: 0 0.25rem;\n    }\n\n    @include respond-to(md) {\n      max-width: 48rem;\n      padding: 0 1rem;\n    }\n  }\n\n  .input-actions {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-left: 8px;\n    margin-right: 8px;\n\n    .upload-btn {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      cursor: pointer;\n      opacity: 0.6;\n      transition: opacity 0.15s ease, background-color 0.15s ease;\n\n      &:hover {\n        opacity: 1;\n        background-color: rgba(0, 0, 0, 0.08);\n      }\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n    }\n\n    .voice-btn {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      border: none;\n      background: transparent;\n      cursor: pointer;\n      opacity: 0.6;\n      transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n\n      &:hover {\n        opacity: 1;\n        background-color: rgba(0, 0, 0, 0.08);\n      }\n\n      &.recording {\n        opacity: 1;\n        background-color: #f44336;\n        color: white;\n        animation: pulse-recording 1.5s ease-in-out infinite;\n      }\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n\n  @keyframes pulse-recording {\n    0%, 100% {\n      box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);\n    }\n    50% {\n      box-shadow: 0 0 0 8px rgba(244, 67, 54, 0);\n    }\n  }\n\n  .pending-image-preview {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px 16px;\n    position: relative;\n    max-width: 100%;\n\n    img {\n      max-height: 120px;\n      max-width: 200px;\n      border-radius: 8px;\n      object-fit: contain;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    }\n\n    .remove-image-btn {\n      position: absolute;\n      top: 0;\n      right: calc(50% - 108px);\n      width: 24px;\n      height: 24px;\n      border-radius: 50%;\n      border: none;\n      background: rgba(0, 0, 0, 0.6);\n      color: white;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: background-color 0.15s ease;\n\n      &:hover {\n        background: rgba(0, 0, 0, 0.8);\n      }\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n      }\n    }\n  }\n\n  .mistake-warning {\n    font-size: 0.75rem;\n    line-height: 1rem;\n    text-align: center;\n    padding: 0.5rem 0;\n  }\n}\n\n/* Agent selector - matches model-selector styling in header-bar */\n.agent-selector {\n  box-sizing: border-box;\n  font-weight: 600;\n  font-size: 1rem;\n  width: 280px;\n  height: 2.5rem;\n  line-height: 1.75rem;\n  padding: 0.375rem 0.75rem;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  align-items: center;\n  display: flex;\n  white-space: nowrap;\n  user-select: none;\n\n  ::ng-deep .mat-mdc-select-trigger {\n    height: 100%;\n  }\n\n  ::ng-deep .mat-mdc-select-value {\n    max-width: 100%;\n  }\n\n  ::ng-deep .mat-mdc-select-arrow-wrapper {\n    padding-left: 8px;\n  }\n}\n\n.agent-listing {\n  display: grid;\n  grid-template-columns: min-content 1fr;\n  gap: 0 10px;\n  align-items: center;\n\n  .agent-icon {\n    width: 24px;\n    height: 24px;\n    font-size: 24px;\n    color: var(--primary-color, #1976d2);\n  }\n\n  .agent-name {\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.chat-history-container {\n  display: flex;\n  height: 100%;\n  min-width: 200px;\n  max-width: 500px;\n  padding: 0.75rem;\n  padding-top: 0;\n  flex-direction: column;\n  flex-shrink: 0;\n  container-type: inline-size;  // Enable container queries\n  container-name: sidebar;\n  // Scrollbar colors set by theme below\n\n  // Prevent text selection in selection mode\n  &.selection-mode {\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n  }\n\n  .nav-action-bar {\n    display: flex;\n    align-items: center;\n    padding: 0.25rem 0.5rem;\n    // Colors set by _chat-widget-theme.scss\n\n    .nav-logo {\n      height: 30px;\n      width: auto;\n      object-fit: contain;\n      object-position: left center;\n    }\n  }\n\n  // Combined search + session actions row\n  .search-action-row {\n    display: flex;\n    align-items: center;\n    padding: 0.5rem 0;\n    gap: 0.25rem;\n\n    .search-field {\n      flex: 1;\n      min-width: 0;\n\n      ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n        display: none;\n      }\n\n      ::ng-deep .mat-mdc-text-field-wrapper {\n        padding: 0 0.5rem;\n      }\n\n      ::ng-deep .mat-mdc-form-field-infix {\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n        min-height: unset;\n      }\n\n      ::ng-deep input {\n        font-size: 0.8125rem;\n      }\n\n      mat-icon[matPrefix] {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n        margin-right: 0.25rem;\n        opacity: 0.6;\n      }\n\n      ::ng-deep .mat-mdc-form-field-icon-suffix {\n        display: flex;\n        align-items: center;\n        padding-right: 0.25rem;\n      }\n\n      mat-spinner {\n        margin-left: 0.25rem;\n        flex-shrink: 0;\n      }\n    }\n\n    // Action buttons (new chat, kebab)\n    > .action-btn {\n      width: 32px;\n      height: 32px;\n      padding: 0;\n      flex-shrink: 0;\n\n      mat-icon {\n        font-size: 20px;\n        line-height: 32px;\n        width: 24px;\n        height: 24px;\n      }\n\n      ::ng-deep .mat-mdc-button-touch-target {\n        width: 32px;\n        height: 32px;\n      }\n\n      // New chat — accent with primary color\n      &.new-chat-btn mat-icon {\n        color: var(--preset-primary, var(--mat-theme-primary, #1976d2)) !important;\n      }\n    }\n\n    // Selection mode bar\n    &.selection-bar {\n      .selection-count {\n        font-size: 0.8125rem;\n        font-weight: 600;\n        color: var(--preset-primary, var(--mat-theme-primary, #1976d2));\n        white-space: nowrap;\n      }\n\n      .flex-spacer {\n        flex: 1;\n      }\n    }\n  }\n\n  .chat-history {\n    display: flex;\n    flex-direction: column;\n    gap: var(--density-spacing, 1rem);\n    margin: 0.5rem 0;\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    overflow: hidden auto;\n    flex: 1;\n  }\n\n  .chat-history-block {\n    position: relative;\n\n    .block-header {\n      position: sticky;\n      top: 0;\n\n      span {\n        padding: 0.75rem 0.5rem 0.5rem;\n        font-weight: 600;\n        word-break: break-all;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        pointer-events: none;\n        cursor: default;\n      }\n    }\n  }\n}\n\n.chat-history-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n\n  li {\n    border-radius: 0.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--density-padding, 0.5rem);\n    cursor: pointer;\n  }\n}\n\n\n// ============================================================================\n// Sidebar Resize Divider\n// ============================================================================\n\n.sidebar-resize-divider {\n  width: 4px;\n  cursor: ew-resize;\n  background-color: var(--resize-divider-color, transparent);\n  transition: background-color 0.15s ease, width 0.15s ease;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: var(--primary-color, #1976d2);\n    opacity: 0.5;\n  }\n\n  // When sidebar is collapsed, widen the grab handle and change cursor\n  &.collapsed {\n    width: 6px;\n    cursor: e-resize;\n    opacity: 0.7;\n\n    &:hover {\n      width: 8px;\n      opacity: 1;\n    }\n  }\n}\n\n// ============================================================================\n// Open Apps Section (sidebar)\n// ============================================================================\n\n.open-apps-section {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--border-color, rgba(128, 128, 128, 0.2));\n\n  .open-apps-header {\n    padding: 0 0.5rem 0.5rem;\n\n    span {\n      font-weight: 600;\n      font-size: 0.875rem;\n      color: var(--text-secondary, rgba(128, 128, 128, 0.8));\n    }\n  }\n\n  .open-apps-list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    li {\n      display: flex;\n      align-items: center;\n      padding: 0.375rem 0.5rem;\n      border-radius: 0.5rem;\n      cursor: pointer;\n      transition: background-color 0.15s ease;\n\n      &:hover {\n        background-color: var(--hover-color, rgba(0, 0, 0, 0.04));\n      }\n\n      &.active {\n        background-color: var(--active-color, rgba(var(--primary-color-rgb, 25, 118, 210), 0.12));\n      }\n\n      .app-icon {\n        width: 18px;\n        height: 18px;\n        font-size: 18px;\n        margin-right: 0.5rem;\n        color: var(--primary-color, #1976d2);\n      }\n\n      .app-name {\n        flex: 1;\n        font-size: 0.875rem;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .close-app-btn {\n        width: 20px;\n        height: 20px;\n        padding: 0;\n        opacity: 0;\n        transition: opacity 0.15s ease;\n\n        mat-icon {\n          width: 16px;\n          height: 16px;\n          font-size: 16px;\n        }\n      }\n\n      &:hover .close-app-btn {\n        opacity: 0.6;\n\n        &:hover {\n          opacity: 1;\n        }\n      }\n    }\n  }\n}\n\n// ============================================================================\n// Split Content Area (App Pane + Chat)\n// ============================================================================\n\n.split-content-area {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n  min-height: 0;\n  position: relative;\n  z-index: 1;\n}\n\n.app-pane {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 100px;\n  flex-shrink: 0;\n\n  &.hidden {\n    height: 0 !important;\n    min-height: 0 !important;\n    overflow: hidden;\n  }\n\n  .app-tabs-bar {\n    display: flex;\n    align-items: center;\n    padding: 0 0.5rem;\n    min-height: 36px;\n    background-color: var(--surface-color, rgba(128, 128, 128, 0.05));\n    border-bottom: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));\n\n    > .pane-toggle-btn {\n      margin-right: 0.25rem;\n    }\n\n    .app-tabs {\n      display: flex;\n      flex: 1;\n      overflow-x: auto;\n      gap: 2px;\n\n      &::-webkit-scrollbar {\n        height: 4px;\n      }\n\n      .app-tab {\n        display: flex;\n        align-items: center;\n        padding: 0.375rem 0.5rem;\n        border-radius: 0.375rem 0.375rem 0 0;\n        cursor: pointer;\n        font-size: 0.8125rem;\n        white-space: nowrap;\n        transition: background-color 0.15s ease, color 0.15s ease;\n        border: 1px solid transparent;\n        border-bottom: none;\n        height: 28px;\n        box-sizing: border-box;\n        color: var(--text-secondary, rgba(0, 0, 0, 0.6));\n\n        &:hover {\n          background-color: var(--hover-color, rgba(0, 0, 0, 0.04));\n          color: var(--text-primary, rgba(0, 0, 0, 0.87));\n        }\n\n        &.active {\n          background-color: var(--surface-color, rgba(128, 128, 128, 0.1));\n          border-color: var(--border-color, rgba(128, 128, 128, 0.2));\n          color: inherit;\n        }\n\n        .tab-icon {\n          width: 16px;\n          height: 16px;\n          font-size: 16px;\n          margin-right: 0.375rem;\n          flex-shrink: 0;\n        }\n\n        .tab-name {\n          margin-right: 0.375rem;\n          line-height: 1;\n        }\n\n        .tab-close {\n          width: 16px;\n          height: 16px;\n          min-width: 16px;\n          min-height: 16px;\n          padding: 0;\n          opacity: 0.5;\n          transition: opacity 0.15s ease;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          flex-shrink: 0;\n          line-height: 1;\n\n          ::ng-deep .mat-mdc-button-touch-target {\n            width: 16px;\n            height: 16px;\n          }\n\n          mat-icon {\n            width: 14px;\n            height: 14px;\n            font-size: 14px;\n            line-height: 14px;\n          }\n\n          &:hover {\n            opacity: 1;\n          }\n        }\n      }\n    }\n\n  }\n\n  .app-content {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    .app-instance {\n      flex: 1;\n      min-height: 0;\n      overflow: hidden;\n      flex-direction: column;\n\n      &.active {\n        display: flex;\n      }\n\n      // Ensure embedded widgets fill the space\n      > * {\n        flex: 1;\n        min-height: 0;\n        overflow: auto;\n      }\n    }\n  }\n}\n\n.resize-divider {\n  height: 6px;\n  cursor: ns-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--border-color, rgba(128, 128, 128, 0.2));\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: var(--primary-color, #1976d2);\n  }\n\n  .divider-handle {\n    width: 32px;\n    height: 4px;\n    border-radius: 2px;\n    background-color: var(--text-secondary, rgba(128, 128, 128, 0.5));\n  }\n\n  &:hover .divider-handle {\n    background-color: white;\n  }\n}\n\n.chat-area {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;  // Take remaining space after user-input\n  min-height: 0;  // Allow shrinking in flex context\n\n  &.full-height {\n    height: 100% !important;\n  }\n\n  &.hidden {\n    height: 0 !important;\n    min-height: 0 !important;\n    overflow: hidden;\n    flex: 0 !important;  // Don't take space when hidden\n  }\n\n  .chat-header-bar {\n    display: flex;\n    align-items: center;\n    padding: 0 0.5rem;\n    min-height: 28px;\n    background-color: var(--surface-color, rgba(128, 128, 128, 0.05));\n    border-bottom: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));\n    flex-shrink: 0;\n\n    > .pane-toggle-btn {\n      margin-right: 0.25rem;\n    }\n\n    .chat-label {\n      font-size: 0.75rem;\n      font-weight: 600;\n      color: var(--text-secondary, rgba(128, 128, 128, 0.8));\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n\n    .close-chat-btn {\n      width: 24px;\n      height: 24px;\n      padding: 0;\n      opacity: 0.6;\n      transition: opacity 0.15s ease;\n\n      mat-icon {\n        width: 18px;\n        height: 18px;\n        font-size: 18px;\n      }\n\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n\n  .chat-expand-bar {\n    display: flex;\n    align-items: center;\n    padding: 0 0.5rem;\n    min-height: 28px;\n    background-color: var(--surface-color, rgba(128, 128, 128, 0.05));\n    border-bottom: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));\n\n    .show-apps-btn {\n      width: 24px;\n      height: 24px;\n      padding: 0;\n\n      mat-icon {\n        width: 18px;\n        height: 18px;\n        font-size: 18px;\n      }\n    }\n\n    .apps-hidden-label {\n      font-size: 0.75rem;\n      font-weight: 500;\n      color: var(--text-secondary, rgba(128, 128, 128, 0.8));\n      margin-left: 0.25rem;\n    }\n  }\n}\n\n.show-chat-bar {\n  display: flex;\n  align-items: center;\n  padding: 0 0.5rem;\n  min-height: 28px;\n  background-color: var(--surface-color, rgba(128, 128, 128, 0.05));\n  border-top: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));\n  flex-shrink: 0;\n\n  .show-chat-btn {\n    width: 24px;\n    height: 24px;\n    padding: 0;\n\n    mat-icon {\n      width: 18px;\n      height: 18px;\n      font-size: 18px;\n    }\n  }\n\n  .chat-hidden-label {\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: var(--text-secondary, rgba(128, 128, 128, 0.8));\n    margin-left: 0.25rem;\n  }\n}\n\n// ============================================================================\n// Collapsed Pane Bars (pinned restore bars when a pane is hidden)\n// ============================================================================\n\n.collapsed-pane-bar {\n  display: flex;\n  align-items: center;\n  padding: 0 0.5rem;\n  min-height: 28px;\n  background-color: var(--surface-color, rgba(128, 128, 128, 0.05));\n  flex-shrink: 0;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: var(--hover-color, rgba(128, 128, 128, 0.1));\n  }\n\n  &.top {\n    border-bottom: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));\n  }\n\n  &.bottom {\n    border-top: 1px solid var(--border-color, rgba(128, 128, 128, 0.15));\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n\n  .restore-pane-icon {\n    width: 18px;\n    height: 18px;\n    font-size: 18px;\n    opacity: 0.7;\n  }\n\n  .collapsed-pane-label {\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: var(--text-secondary, rgba(128, 128, 128, 0.8));\n    margin-left: 0.25rem;\n  }\n}\n\n// Pane collapse/expand toggle button\n.pane-toggle-btn {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  opacity: 0.6;\n  transition: opacity 0.15s ease;\n\n  mat-icon {\n    width: 18px;\n    height: 18px;\n    font-size: 18px;\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.session-button {\n  --session-button-size: 24px;\n  --session-icon-size: 18px;\n\n  width: var(--session-button-size, 48px);\n  height: var(--session-button-size, 48px);\n  padding: 0px;\n  border-radius: 0.5rem;\n\n  mat-icon {\n    width: var(--session-icon-size, 24px);\n    height: var(--session-icon-size, 24px);\n    line-height: var(--session-icon-size, 24px);\n    font-size: var(--session-icon-size, 24px);\n  }\n\n  ::ng-deep .mat-mdc-button-persistent-ripple {\n    border-radius: 0.5rem;\n  }\n\n  ::ng-deep .mat-mdc-button-touch-target {\n    width: var(--session-button-size, 48px);\n    height: var(--session-button-size, 48px);\n  }\n}\n\ntextarea {\n  max-height: 200px;\n}\n\n/* Control visibility of menubar elements based on isFullScreen attribute */\n:host:not([isfullscreen=\"true\"]) {\n  .header-bar .right.section {\n    display: none !important;\n  }\n}\n\n:host([isfullscreen=\"true\"]) {\n  .header-bar .right.section {\n    display: flex;\n  }\n}\n\n\n/* Always-present actions toolbar - switches between individual and bulk actions */\n.actions-toolbar {\n  min-height: 48px;\n  padding: 0.5rem 0.75rem;\n  border-bottom: 1px solid var(--border-color, #e0e0e0);\n  background-color: var(--surface-color, #f5f5f5);\n  display: flex;\n  align-items: center;\n\n  .individual-actions {\n    width: 100%;\n\n    .actions-content {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .action-hint {\n        font-size: 0.875rem;\n        font-weight: 500;\n        color: var(--text-secondary, #666);\n        flex: 1;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        margin-right: 0.5rem;\n      }\n\n      .individual-buttons {\n        display: flex;\n        gap: 0.25rem;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  .bulk-actions-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n\n    .selection-count {\n      font-size: 0.875rem;\n      font-weight: 500;\n      color: var(--text-secondary, #666);\n    }\n\n    .bulk-actions {\n      display: flex;\n      gap: 0.25rem;\n    }\n  }\n}\n\n/* Enhanced chat history list with consistent heights */\n.chat-history-list {\n  li {\n    // Fixed height for consistency between normal and selection modes\n    min-height: 25px;\n    max-height: 25px;\n\n    // Ensure proper content alignment within the fixed height\n    .session-title {\n      flex: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      user-select: none;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n    }\n\n    // Selection mode specific styles\n    &.selection-mode {\n      user-select: none;\n\n      &:hover:not(.selected) {\n        background-color: var(--hover-color, rgba(0, 0, 0, 0.04));\n      }\n    }\n\n    // Normal mode hover (when not in selection mode)\n    &:not(.selection-mode):hover {\n      background-color: var(--hover-color, rgba(0, 0, 0, 0.04));\n    }\n  }\n}\n\n/* Enhanced button row layout */\n.chat-history-container .button-row {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n\n  // Push the selection button to the right\n  button:last-child {\n    margin-left: auto;\n}\n\n/* Invisible placeholder for consistent spacing */\n.session-placeholder {\n  width: 24px;\n  height: 24px;\n}\n\n/* Session action area - right side for both checkboxes and action buttons */\n.session-action-area {\n  width: 24px;\n  margin-left: 0.5rem;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .session-checkbox {\n    margin: 0;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    ::ng-deep .mat-mdc-checkbox {\n      height: 24px;\n\n      .mdc-checkbox {\n        display: flex;\n        align-items: center;\n        padding: 0;\n      }\n\n      .mdc-form-field {\n        margin: 0;\n        padding: 0;\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    ::ng-deep .mat-checkbox-inner-container {\n      width: 16px;\n      height: 16px;\n      margin: 0;\n    }\n  }\n\n  .session-button {\n    // Keep the standard session button sizing for right side\n    --session-button-size: 24px;\n    --session-icon-size: 18px;\n\n    width: var(--session-button-size);\n    height: var(--session-button-size);\n    padding: 0;\n    margin: 0;\n    border-radius: 0.5rem;\n\n    mat-icon {\n      width: var(--session-icon-size);\n      height: var(--session-icon-size);\n      line-height: var(--session-icon-size);\n      font-size: var(--session-icon-size);\n    }\n  }\n}\n\n}\n\n/* Combined agent/session selector - mobile only */\n.combined-selector-mobile {\n  display: none; /* Hidden by default, shown on mobile via media query */\n  flex: 1;\n  min-width: 0;\n  max-width: 100%;\n  padding: 4px 8px;\n  border-radius: 8px;\n  text-transform: none;\n  font-weight: 500;\n  font-size: 13px;\n\n  .combined-selector-text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    overflow: hidden;\n    text-align: left;\n\n    .agent-badge {\n      font-size: 10px;\n      opacity: 0.7;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n\n    .session-name {\n      font-size: 13px;\n      font-weight: 500;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: 100%;\n    }\n  }\n\n  mat-icon {\n    flex-shrink: 0;\n  }\n}\n\n/* Styling for the combined selector menu panel */\n::ng-deep .combined-selector-panel {\n  max-height: 70vh;\n  min-width: 280px;\n\n  .selector-header {\n    font-weight: 600;\n    background-color: rgba(0, 0, 0, 0.04);\n\n    .current-agent-header {\n      font-weight: 600;\n    }\n  }\n\n  .timeblock-label {\n    padding: 8px 16px 4px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    opacity: 0.6;\n  }\n\n  .session-menu-title {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .active-session,\n  .active-agent {\n    background-color: rgba(var(--primary-color-rgb, 25, 118, 210), 0.12);\n    font-weight: 600;\n  }\n\n  .no-sessions-hint {\n    padding: 12px 16px;\n    font-size: 13px;\n    opacity: 0.6;\n    font-style: italic;\n  }\n\n  // Custom div-based menu items that don't close menu on click\n  .agent-menu-item {\n    display: flex;\n    align-items: center;\n    padding: 0 16px;\n    min-height: 48px;\n    cursor: pointer;\n    gap: 16px;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.04);\n    }\n\n    mat-icon {\n      flex-shrink: 0;\n      color: var(--text-secondary, rgba(0, 0, 0, 0.54));\n    }\n\n    span {\n      flex: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n}\n\n/* Header status chips - unified styling for session ID, token status, usage */\n.header-chips {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.header-chip {\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n  font-size: 0.7rem;\n  letter-spacing: 0.3px;\n  padding: 3px 8px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  user-select: none;\n  transition: opacity 0.15s ease, background-color 0.15s ease;\n  line-height: 1.2;\n\n  mat-icon {\n    font-size: 12px;\n    width: 12px;\n    height: 12px;\n  }\n\n  .chip-label {\n    opacity: 0.7;\n  }\n\n  &:hover {\n    opacity: 0.85;\n  }\n\n  // Neutral/info style (session ID, unknown status)\n  &.chip-neutral {\n    background-color: rgba(128, 128, 128, 0.15);\n    color: rgba(128, 128, 128, 0.9);  // Gray that works in both light and dark mode\n\n    mat-icon {\n      opacity: 0.8;\n    }\n\n    &:hover {\n      background-color: rgba(128, 128, 128, 0.25);\n    }\n  }\n\n  // Success/healthy style\n  &.chip-success {\n    background-color: rgba(76, 175, 80, 0.15);\n    color: #4caf50;\n\n    mat-icon {\n      color: #4caf50;\n    }\n  }\n\n  // Warning style\n  &.chip-warning {\n    background-color: rgba(255, 152, 0, 0.15);\n    color: #ff9800;\n\n    mat-icon {\n      color: #ff9800;\n    }\n  }\n\n  // Error/critical style\n  &.chip-error {\n    background-color: rgba(244, 67, 54, 0.15);\n    color: #f44336;\n\n    mat-icon {\n      color: #f44336;\n    }\n  }\n\n  // Refreshing state\n  &.chip-refreshing {\n    background-color: rgba(128, 128, 128, 0.15);\n    color: rgba(128, 128, 128, 0.9);\n\n    mat-icon.spin {\n      animation: spin 1s linear infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Tooltip styling for multiline content */\n::ng-deep .multiline-tooltip .mdc-tooltip__surface {\n  white-space: pre-line !important;\n  max-width: 280px !important;\n  text-align: left !important;\n}\n\n// Abbreviate header chips when the chat widget is narrow\n@container chat (max-width: 500px) {\n  .header-chip .chip-session-id {\n    display: none; // Just show folder icon\n  }\n\n  .header-chip .chip-label {\n    display: none; // Just show percentage\n  }\n}\n\n// ============================================================================\n// Container-query compact mode: triggers on widget width, not viewport.\n// Works in both dockview (windowed) and fullscreen when the widget is narrow.\n// ============================================================================\n@container chat (max-width: 700px) {\n  // Hide the session sidebar — use combined selector instead\n  .chat-history-container {\n    display: none !important;\n  }\n\n  // Hide the sidebar resize divider too\n  .sidebar-resize-divider {\n    display: none !important;\n  }\n\n  // Show combined agent/session selector — full width\n  .combined-selector-mobile {\n    display: flex !important;\n    width: 100% !important;\n    max-width: none !important;\n\n    // Material button inner wrapper must also stretch\n    ::ng-deep .mdc-button__label {\n      width: 100%;\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  // Hide desktop-only elements, show mobile-only\n  .desktop-only {\n    display: none !important;\n  }\n\n  .mobile-only {\n    display: flex !important;\n  }\n\n  // Override: keep header chips visible as icon-only in compact mode\n  .header-chips.desktop-only {\n    display: flex !important;\n  }\n\n  .header-chip {\n    padding: 3px 5px;\n    gap: 0;\n\n    > span {\n      display: none;\n    }\n  }\n\n  .header-bar .left.section {\n    gap: 0;\n    width: 100%;\n  }\n\n  // Reclaim input area margins\n  .user-input {\n    right: 0;\n    padding-bottom: 0;\n\n    .prompt-box {\n      padding: 10px 0.5rem 0;\n      max-width: 100%;\n    }\n\n    // Kill Material form field subscript gap and internal padding\n    ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n      display: none;\n    }\n\n    ::ng-deep .mat-mdc-form-field-bottom-align {\n      display: none;\n    }\n\n    ::ng-deep .mdc-text-field--filled {\n      padding-bottom: 0;\n    }\n\n    ::ng-deep .mat-mdc-form-field-infix {\n      padding-bottom: 4px;\n    }\n  }\n\n  // Prevent horizontal overflow\n  .main-chat-container,\n  .content,\n  app-chat-screen {\n    overflow-x: hidden;\n    box-sizing: border-box;\n  }\n\n  // Ensure pre/code blocks don't overflow\n  ::ng-deep pre,\n  ::ng-deep code,\n  ::ng-deep .tool-input,\n  ::ng-deep .tool-output {\n    max-width: 100% !important;\n    overflow-x: auto !important;\n    word-break: break-word !important;\n  }\n}\n\n// Even narrower — compact the agent selector further\n@container chat (max-width: 400px) {\n  .agent-selector {\n    max-width: 80px;\n  }\n\n  .header-bar .right.section {\n    gap: 2px;\n  }\n\n  .user-input .input-actions {\n    margin-left: 4px;\n    margin-right: 4px;\n    gap: 2px;\n  }\n\n  // Hide pins pane at very narrow widths — not enough room\n  .pins-pane {\n    display: none !important;\n  }\n\n  .pins-resize-divider {\n    display: none !important;\n  }\n}\n\n/* Desktop-only elements (hidden in compact container mode AND on mobile) */\n.desktop-only {\n  display: flex;\n}\n\n/* Mobile-only elements (hidden on desktop, shown in compact mode and on mobile) */\n.mobile-only {\n  display: none;\n}\n\n\n/* Responsive breakpoints for chat widget in full-screen mode */\n/* Note: Angular sets isfullscreen=\"true\" as a string attribute */\n@media (max-width: 768px) {\n  :host([isfullscreen=\"true\"]) {\n    .chat-history-container {\n      display: none !important;\n    }\n\n    // Show combined selector on mobile\n    .combined-selector-mobile {\n      display: flex !important;\n    }\n\n    // Hide desktop-only elements on mobile\n    .desktop-only {\n      display: none !important;\n    }\n\n    // Show mobile-only elements\n    .mobile-only {\n      display: flex !important;\n    }\n\n    .header-bar .left.section {\n      gap: 4px;\n    }\n\n    .header-bar .right.section {\n      gap: 2px;\n    }\n\n    // Remove any padding from containers on mobile, prevent overflow\n    .main-chat-container {\n      padding: 0;\n      padding-bottom: 0 !important;\n      overflow: hidden;\n    }\n\n    // Small gap between messages and input area\n    .user-input {\n      padding-top: 5px;\n      padding-bottom: 0 !important;\n      margin-bottom: 0 !important;\n    }\n\n    // Use full height on mobile (no titlebar)\n    .chat-container,\n    .gridster-item-content {\n      height: 100% !important;\n      padding: 0 !important;\n      margin: 0 !important;\n    }\n\n    // Prevent horizontal overflow from content\n    .main-chat-container,\n    .content,\n    app-chat-screen,\n    ::ng-deep .messages-container,\n    ::ng-deep .message,\n    ::ng-deep .message-content,\n    ::ng-deep app-tool-message,\n    ::ng-deep .tool-message {\n      max-width: 100vw !important;\n      overflow-x: hidden !important;\n      box-sizing: border-box !important;\n    }\n\n    // Ensure pre/code blocks don't overflow\n    ::ng-deep pre,\n    ::ng-deep code,\n    ::ng-deep .tool-input,\n    ::ng-deep .tool-output {\n      max-width: 100% !important;\n      overflow-x: auto !important;\n      word-break: break-word !important;\n    }\n  }\n}\n\n/* Even narrower screens - make agent selector more compact */\n@media (max-width: 480px) {\n  :host([isfullscreen=\"true\"]) {\n    .agent-selector {\n      max-width: 80px;\n    }\n  }\n}\n\n/* Responsive input area for narrow screens in full-screen mode */\n@media (max-width: 768px) {\n  :host([isfullscreen=\"true\"]) {\n    .user-input {\n      width: 100%;\n\n      .prompt-box {\n        padding: 0 !important;\n        max-width: 100% !important;\n        width: 100%;\n        margin: 0;\n      }\n\n      .input-actions {\n        margin-left: 4px;\n        margin-right: 4px;\n        gap: 2px;\n\n        .upload-btn,\n        .voice-btn {\n          width: 28px;\n          height: 28px;\n\n          mat-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n          }\n        }\n      }\n\n      .form-field {\n        width: 100%;\n        overflow: visible !important;\n\n        // Remove rounded corners on mobile for edge-to-edge feel\n        ::ng-deep .mdc-text-field--filled,\n        ::ng-deep .mat-mdc-text-field-wrapper {\n          border-radius: 0 !important;\n          padding-left: 0 !important;\n          padding-right: 48px !important; // Space for send button\n          overflow: visible !important;\n        }\n\n        // Ensure suffix (send button) is visible and not clipped\n        ::ng-deep .mat-mdc-form-field-icon-suffix {\n          position: absolute;\n          right: 4px;\n          top: 50%;\n          transform: translateY(-50%);\n        }\n\n        // Reduce internal padding\n        ::ng-deep .mat-mdc-form-field-infix {\n          padding-top: 8px !important;\n          padding-bottom: 8px !important;\n          min-height: unset !important;\n        }\n\n        // Hide the subscript area (hints/errors) to save space\n        ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n          display: none !important;\n        }\n      }\n\n      // Textarea: taller minimum for easier thumb tapping, max height for scrolling\n      textarea {\n        min-height: 60px !important; // ~3 lines, easier to tap\n        max-height: 120px !important;\n        overflow-y: auto !important;\n\n        // Hide native placeholder on mobile - we use floating placeholder instead\n        &::placeholder {\n          color: transparent !important;\n          opacity: 0 !important;\n        }\n      }\n\n      // Align input actions (buttons) to center of the taller textarea\n      .input-actions {\n        align-self: center;\n      }\n\n      // Recording indicator - red background like lit-mux\n      .form-field.recording {\n        ::ng-deep .mdc-text-field--filled {\n          background-color: #f44336 !important;\n        }\n\n        textarea {\n          color: white !important;\n\n          &::placeholder {\n            color: rgba(255, 255, 255, 0.8) !important;\n          }\n        }\n      }\n\n      // Floating placeholder - vertically centered, click-through, disappears on focus\n      .form-field {\n        position: relative;\n\n        .mobile-placeholder {\n          position: absolute;\n          left: 12px;\n          top: 50%;\n          transform: translateY(-50%);\n          pointer-events: none;\n          color: var(--text-secondary, rgba(128, 128, 128, 0.8));\n          font-size: 16px;\n          z-index: 1;\n          transition: opacity 0.15s ease;\n\n          &.recording {\n            color: rgba(255, 255, 255, 0.9);\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  :host([isfullscreen=\"true\"]) {\n    .user-input {\n      .input-actions {\n        margin-left: 2px;\n        margin-right: 2px;\n\n        .upload-btn,\n        .voice-btn {\n          width: 26px;\n          height: 26px;\n\n          mat-icon {\n            font-size: 16px;\n            width: 16px;\n            height: 16px;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Pin badge active state\n.header-chip.chip-active {\n  background-color: rgba(25, 118, 210, 0.15) !important;\n  color: var(--tool-accent, #1976d2) !important;\n\n  mat-icon {\n    color: var(--tool-accent, #1976d2) !important;\n  }\n}\n\n// Pins pane resize divider (mirrors sidebar-resize-divider)\n.pins-resize-divider {\n  width: 4px;\n  cursor: ew-resize;\n  background-color: var(--resize-divider-color, transparent);\n  transition: background-color 0.15s ease;\n  flex-shrink: 0;\n\n  &:hover {\n    background-color: var(--primary-color, #1976d2);\n    opacity: 0.5;\n  }\n}\n\n// Pins pane — right-side flex panel (mirrors session sidebar)\n.pins-pane {\n  display: flex;\n  height: 100%;\n  min-width: 15%;\n  max-width: 50%;\n  flex-direction: column;\n  flex-shrink: 0;\n  overflow: hidden;\n  // Colors set by _chat-widget-theme.scss\n\n  .pins-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 12px;\n    flex-shrink: 0;\n\n    .pins-header-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      opacity: 0.7;\n    }\n\n    .pins-title {\n      font-weight: 600;\n      font-size: 14px;\n    }\n\n    .flex-spacer {\n      flex: 1;\n    }\n  }\n\n  .pins-list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 8px 0;\n  }\n\n  .pin-card {\n    padding: 10px 12px;\n    transition: background 0.1s ease;\n\n    &.kg-card {\n      height: 158px;\n      box-sizing: border-box;\n      display: flex;\n      flex-direction: column;\n\n      .pin-card-header { flex-shrink: 0; }\n      .pin-card-content { max-height: none !important; flex: 1; }\n    }\n\n    .pin-card-header {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      margin-bottom: 6px;\n\n      .flex-spacer {\n        flex: 1;\n      }\n\n      .pin-role-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n      }\n\n      .pin-timestamp {\n        font-size: 11px;\n      }\n\n      .jump-btn,\n      .unpin-btn {\n        --square-button-size: 24px;\n        --square-icon-size: 14px;\n        transition: opacity 0.15s ease;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        mat-icon {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n      }\n\n      .jump-btn {\n        opacity: 0.5;\n\n        &:hover {\n          opacity: 1;\n        }\n      }\n\n      .unpin-btn {\n        opacity: 0.5;\n\n        &:hover {\n          opacity: 1;\n        }\n      }\n    }\n\n    .pin-card-content {\n      font-size: 13px;\n      line-height: 1.5;\n      overflow: hidden;\n\n      &:not(.expanded) {\n        max-height: 120px;\n        mask-image: linear-gradient(to bottom, black 70%, transparent 100%);\n        -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 100%);\n      }\n\n      // Scale down rendered markdown in pin cards\n      ::ng-deep {\n        h1, h2, h3, h4 { font-size: 14px; margin: 4px 0; }\n        p { margin: 4px 0; }\n        pre { font-size: 11px; padding: 6px; overflow-x: auto; }\n        ul, ol { padding-left: 20px; margin: 4px 0; }\n        code { font-size: 12px; }\n        // Constrain tool messages in pin cards\n        app-tool-message { display: block; }\n      }\n    }\n\n    .show-more-btn {\n      font-size: 11px;\n      padding: 0 4px;\n      min-height: 24px;\n      line-height: 24px;\n    }\n  }\n\n  .pins-empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 32px 16px;\n    opacity: 0.5;\n    font-size: 13px;\n  }\n\n  .pins-graph-container {\n    flex: 1;\n    overflow: hidden;\n    position: relative;\n\n    app-knowledge-graph-widget {\n      display: block;\n      width: 100%;\n      height: 100%;\n\n      ::ng-deep {\n        .widget-body {\n          height: 100%;\n        }\n      }\n    }\n  }\n\n  .pins-node-count {\n    font-size: 11px;\n    opacity: 0.6;\n    margin-left: -4px;\n  }\n\n  .kg-msg-loading {\n    font-size: 12px;\n    opacity: 0.5;\n    padding: 4px 0;\n\n    .shimmer-lines {\n      .shimmer-line {\n        height: 10px;\n        border-radius: 3px;\n        background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);\n        background-size: 200% 100%;\n        animation: shimmer 1.5s infinite;\n        margin-bottom: 6px;\n\n        &:nth-child(1) { width: 90%; }\n        &:nth-child(2) { width: 70%; }\n        &:nth-child(3) { width: 50%; }\n      }\n    }\n\n    @keyframes shimmer {\n      0% { background-position: 200% 0; }\n      100% { background-position: -200% 0; }\n    }\n  }\n\n  .kg-msg-excerpt {\n    font-size: 12px;\n    opacity: 0.6;\n    line-height: 1.4;\n    font-style: italic;\n  }\n\n  .kg-filter-bar {\n    display: flex;\n    align-items: center;\n    padding: 4px 12px 4px 8px;\n    gap: 6px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n\n    .kg-filter-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      opacity: 0.4;\n    }\n\n    .kg-filter-input {\n      flex: 1;\n      background: transparent;\n      border: none;\n      outline: none;\n      color: inherit;\n      font-size: 12px;\n      padding: 4px 0;\n\n      &::placeholder { opacity: 0.4; }\n    }\n\n    .kg-filter-count {\n      font-size: 11px;\n      opacity: 0.5;\n      white-space: nowrap;\n    }\n\n    .kg-filter-clear {\n      font-size: 14px;\n      width: 14px;\n      height: 14px;\n      cursor: pointer;\n      opacity: 0.4;\n\n      &:hover { opacity: 0.8; }\n    }\n  }\n\n  .kg-no-results {\n    padding: 16px 12px;\n    font-size: 12px;\n    opacity: 0.5;\n    text-align: center;\n  }\n}\n","$breakpoints: (\n  'xs': 0px,\n  'sm': 576px,\n  'md': 768px,\n  'lg': 992px,\n  'xl': 1200px,\n  'xxl': 1400px,\n  'xxxl': 2100px\n) !default;\n\n@mixin respond-to($breakpoint) {\n  @if map-has-key($breakpoints, $breakpoint) {\n    @media (min-width: map-get($breakpoints, $breakpoint)) {\n      @content;\n    }\n  } @else {\n    @warn \"Unfortunately, no value could be retrieved from `#{$breakpoint}`. Available breakpoints are: #{map-keys($breakpoints)}.\";\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
